/*globals google*/
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('OrderFormController', OrderFormController);

    OrderFormController.$inject = [
        'ordersService',
        'clientService',
        '$stateParams',
        'genericDataService',
        '$rootScope',
        '$state',
        '$filter',
        'ModalService',
        '$templateCache',
        'constants',
        'endPoints',
        'NgMap',
        '$timeout',
        '$scope',
        'userService',
        'reportService',
        'notificationService',
        '$q',
        'simpleModalService',
        'preferences',
        'modals',
        'common'
    ];

    /* jshint maxstatements:false */
    /* jshint maxparams:false */
    function OrderFormController(
        ordersService,
        clientService,
        $stateParams,
        genericDataService,
        $rootScope,
        $state,
        $filter,
        ModalService,
        $templateCache,
        constants,
        endPoints,
        NgMap,
        $timeout,
        $scope,
        userService,
        reportService,
        notificationService,
        $q,
        simpleModalService,
        preferences,
        modals,
        common
    ) {

        //TODO: Campos extra y lineas impuesto
        //TODO: Generación de informes
        //TODO: Timeline
        //TODO: Cambio de estado (operaciónes extra, preguntar a javier)

        /* PRIVATE VARIABLES */
        var orderId = $stateParams.id;
        var preloadOrder = $stateParams.preload;
        var modalTemplate = $templateCache.get('app/views/modals/directionsTemplate.html');
        var defaultVal = {};
        var needToRetarifar = false;
        var currentAddressDb = null;

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.reportService = reportService;
        vm.stateParams = $stateParams;
        vm.showDatInc = true;
        vm.orden = {};
        vm.preferences = preferences;
        vm.esPosiblePasarActiva = false;
        vm.savedToRetarifar = false;
        vm.tiempoDeProgramacion = preferences.prefs.companyPrefs.tiempoordenprog;
        vm.genericData = {
            clients: {
                list: null,
                selected: {},
                icons: {
                    0: 'content/img/aseguradoras/asitur/asitur-imagotipo.png',
                    1: 'content/img/aseguradoras/racc/racc-imagotipo.png',
                    2: 'content/img/aseguradoras/mapfre/mapfre-imagotipo.png',
                    3: 'content/img/aseguradoras/europ/europ-imagotipo.png',
                    4: 'content/img/aseguradoras/mm/mm-imagotipo.png',
                    5: 'content/img/aseguradoras/race/race-imagotipo.png',
                    6: 'content/img/aseguradoras/allianz/allianz-imagotipo.png',
                    7: 'content/img/aseguradoras/pelayo/pelayo-imagotipo.png',
                    8: 'content/img/aseguradoras/ld/ld-imagotipo.png',
                }
            },
            empresas: {
                list: null,
                selected: {}
            },
            tarifas: {
                list: null,
                selected: {}
            },
            productos: {
                list: null,
                selected: {}
            },
            vehicleBrands: {
                list: null,
                selected: {}
            },
            vehicleModels: {
                fullList: null,
                list: null,
                selected: {}
            },
            paises: {
                list: null,
                selectedAseg: {},
                selectedRec: {},
                selectedEnt: {}
            },
            provinces: {
                aseg: {
                    list: null,
                    selected: {},
                },
                recogida: {
                    list: null,
                    selected: {}
                },
                entrega: {
                    list: null,
                    selected: {}
                }
            },
            poblaciones: {
                aseg: {
                    list: null,
                    selected: {},
                },
                recogida: {
                    list: null,
                    selected: {}
                },
                entrega: {
                    list: null,
                    selected: {}
                }
            },
            colectivos: {
                list: null,
                selected: {}
            },
            tiposFlota: {
                list: null,
                selected: {}
            },
            tiposSubFlota: {
                fullList: null,
                list: null,
                selected: {}
            },
            vehicleColors: {
                list: null,
                selected: {}
            },
            tiposVehiculo: {
                list: null,
                selected: {}
            },
            tiposIncidencia: {
                list: null,
                selected: {},
                selectedFin: {}
            },
            averias: {
                default: {
                    list: null,
                    selected: {}
                },
                fin: {
                    list: null,
                    selected: {}
                }
            },
            bases: {
                list: null,
                selectedRec: {},
                selectedEnt: {},
                selectedSalida: {}
            },
            talleres: {
                list: null,
                selectedRec: {},
                selectedEnt: {}
            },
            colaboradores: {
                list: null,
                loading: false,
                selectedRec: {},
                selectedEnt: {},
                selectedAssignmentData: {}
            },
            operarios: {
                list: null,
                selected: {}
            },
            vehiculos: {
                list: null,
                selected: {}
            },
            tiposFin: {
                list: null,
                selected: {}
            },
            formasPago: {
                list: null,
                selected: {}
            },
            tiposOrden: {
                list: null,
                selected: {}
            },
            tiposRecogida: {
                list: [
                    { id: 'D', nombre: 'Direccion', showField: false },
                    { id: 'B', nombre: 'Base', showField: true },
                    { id: 'P', nombre: 'Parking', showField: false },
                    { id: 'T', nombre: 'Taller', showField: true },
                    { id: 'C', nombre: 'Colaborador', showField: true }
                ],
                selected: { id: 'D', nombre: 'Direccion', showField: false }
            },
            tiposEntrega: {
                list: [
                    { id: 'D', nombre: 'Direccion', showField: false },
                    { id: 'B', nombre: 'Base', showField: true },
                    { id: 'T', nombre: 'Taller', showField: true },
                    { id: 'C', nombre: 'Colaborador', showField: true }
                ],
                selected: { id: 'D', nombre: 'Direccion', showField: false }
            },
            nocFes: {
                list: [
                    { id: 'D', nombre: 'Diurno' },
                    { id: 'N', nombre: 'Nocturno' },
                    { id: 'F', nombre: 'Festivo' }
                ],
                selected: {}
            },

            // address searcher cache
            addressSearcherPaises: {
                list: null,
                recogida: {
                    selected: {}
                },
                entrega: {
                    selected: {}
                }
            },
            addressSearcherProvincias: {
                recogida: {
                    list: null,
                    selected: {}
                },
                entrega: {
                    list: null,
                    selected: {}
                }
            },
            addressSearcherPoblaciones: {
                recogida: {
                    list: null,
                    selected: {}
                },
                entrega: {
                    list: null,
                    selected: {}
                }
            },
        };
        vm.estadoFac = {
            0: 'Pendiente finalización',
            1: 'Pendiente valoracion',
            2: 'Valorado',
            3: 'Facturado',
            99: 'No facturable'
        };
        vm.estado = {
            null: 'Estado de la orden',
            0: 'Pte. Asignar',
            1: 'Asignado',
            2: 'Aceptado',
            3: 'Rechazado',
            4: 'Iniciado',
            5: 'Localizado',
            6: 'Entregado',
            10: 'Finalizado',
            11: 'Ocupado',
            12: 'Desconectado',
            colors: {
                0: 'green',
                1: 'red',
                2: 'blue',
                3: 'burdeos',
                4: 'orange',
                5: 'yellow',
                6: 'violet',
                10: 'black'
            }
        };
        vm.dates = {
            orden: Date.NewDate(),
            alta: null,
            asignacion: null,
            entrega: null,
            finalizado: null,
            aceptado: null,
            inicio: null,
            localizacion: null,
            entPrev: null,
            recPrev: null
        };
        vm.observaciones = {
            obs: {
                list: [],
                add: null
            },
            internas: {
                list: [],
                add: null
            },
            cliente: {
                list: [],
                add: null
            }
        };

        vm.images = [];
        vm.from = '';
        vm.tab = '';

        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfState($state.$current.name)];

        //vm.tab.modified = $scope.orderForm.$dirty;
        vm.linea = {};
        vm.selectedReport = reportService.listReports(vm.orden.orderTipo).default;


        /* PUBLIC FUNCTIONS */
        vm.isEditar = isEditar;
        vm.addObservacion = addObservacion;
        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.remove = remove;
        vm.print = print;
        vm.addImage = addImage;
        vm.addLineaOrden = addLineaOrden;
        vm.removeLineaOrden = removeLineaOrden;
        vm.changeStatus = changeStatus;
        vm.onCompanyChange = onCompanyChange;
        vm.onClientChange = onClientChange;
        vm.onTarifaChange = onTarifaChange;
        vm.onProductoChange = onProductoChange;
        vm.onPaisEntChange = onPaisEntChange;
        vm.onPaisRecChange = onPaisRecChange;
        vm.onPaisAsegChange = onPaisAsegChange;
        vm.onProvEntChange = onProvEntChange;
        vm.onProvRecChange = onProvRecChange;
        vm.onPobRecChange = onPobRecChange;
        vm.onPobEntChange = onPobEntChange;
        vm.onProvAsegChange = onProvAsegChange;
        vm.onTipoFlotaChange = onTipoFlotaChange;
        vm.onAveriaChange = onAveriaChange;
        vm.onAveriaFinChange = onAveriaFinChange;
        vm.onBaseEntSelected = onBaseEntSelected;
        vm.onBaseRecSelected = onBaseRecSelected;
        vm.onTallerEntSelected = onTallerEntSelected;
        vm.onTallerRecSelected = onTallerRecSelected;
        vm.onColabEntSelected = onColabEntSelected;
        vm.onColabRecSelected = onColabRecSelected;
        vm.onModelChange = onModelChange;
        vm.onTipoSubFlotaChange = onTipoSubFlotaChange;
        vm.showDirectionsModal = showDirectionsModal;
        vm.showField = showField;
        vm.callRetarifar = callRetarifar;
        vm.recalcularTotal = recalcularTotal;
        vm.volverListado = volverListado;
        vm.calcular = calcular;
        vm.effectClass = effectClass;
        vm.pasarComoActiva = pasarComoActiva;
        vm.onOrderDateChange = onOrderDateChange;
        vm.onEntDirChange = onEntDirChange;
        vm.onRecDirChange = onRecDirChange;
        vm.setDemoraConf = setDemoraConf;
        vm.copyFromDriver = copyFromDriver;
        vm.clearRecDir = clearRecDir;
        vm.clearEntDir = clearEntDir;
        vm.onClientTryChange = onClientTryChange;
        vm.onRecAddressChange = onRecAddressChange;
        vm.onEntAddressChange = onEntAddressChange;

        vm.bloodhoundPoblaciones = null;
        vm.bloodhoundProvincias = null;
        vm.bloodhoundPaises = null;

        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];
        vm.isNewForm = true;
        vm.isScheduled = $stateParams.programada === true;
        vm.showDateFormGroup = !(vm.isNewForm && vm.isScheduled);
        vm.toggleDateFormGroup = toggleDateFormGroup;
        vm.fechaError = false;

        vm.assignmentDataSelected = 0;
        vm.assignmentDataMustShowVehicleAndOperator = false;

        var EVT_TYPE__PAIS_CHANGED = 'pais-changed';
        var EVT_TYPE__PROVINCIA_CHANGED = 'provincia-changed';
        var EVT_TYPE__POBLACION_CHANGED = 'poblacion-changed';

        /* INITIALIZER */
        (function () {

            document.addEventListener(EVT_TYPE__PAIS_CHANGED, function (e) {
            }, false);

            document.addEventListener(EVT_TYPE__PROVINCIA_CHANGED, function (e) {
                if (vm.bloodhoundPaises === null)
                    return;

                var result = vm.bloodhoundPaises.get(e.detail.data.idpa);
                if (e.detail.sender === 'rec') {
                    vm.genericData.paises.selectedRec = result[0];
                } else if (e.detail.sender === 'ent') {
                    vm.genericData.paises.selectedEnt = result[0];
                }

            }, false);

            document.addEventListener(EVT_TYPE__POBLACION_CHANGED, function (e) {
                if (vm.bloodhoundProvincias === null)
                    return;

                var identifier = e.detail.data.idpr + e.detail.data.idpa;
                var result = vm.bloodhoundProvincias.get(identifier);
                var r = {};
                if (result.length > 0) {
                    r = result[0];
                    if (result.length > 1) {
                        for (var i = 1; i < result.length; i++) {
                            if (result[i].idpa === e.detail.data.idpa)
                                r = result[0];
                        }
                    }
                }

                if (e.detail.sender === 'rec') {
                    vm.genericData.provinces.selectedRec = r;
                } else if (e.detail.sender === 'ent') {
                    vm.genericData.provinces.selectedEnt = r;
                }

            }, false);

            //Edit Order
            getPathFrom();
            if (orderId != null) {
                ordersService.getOrderById(orderId)
                    .then(function (res) {
                        vm.orden = res.data;
                        vm.tab.title = 'Orden Nº ' + vm.orden.id;
                        vm.tab.updateTitle = false;
                        pasarActiva();
                        setDates();
                        setObservaciones();
                        setCombosInitialData();
                        vm.isNewForm = false;
                        if (preferences.prefs.sector === 'TAX' && !vm.orden.orderTaxPax) {
                            vm.orden.orderTaxPax = 1;
                        }
                    });

                ordersService.getOrdenLineas(orderId)
                    .then(function (res) {
                        vm.lineasOrden = res.data;
                    });

                getLineasImpuesto(orderId);

                ordersService.getOrdenImagenes(orderId)
                    .then(function (res) {
                        res.data.forEach(element => {
                            vm.images.push({ data: element });
                        });
                    });
            }
            //New Order
            else {
                vm.isNewOrder = true;
                setCombosInitialDataDefault();
                vm.changeStatus(null);
                defaultValues();
                if (preferences.prefs.sector === 'TAX' && !vm.orden.orderTaxPax) {
                    vm.orden.orderTaxPax = 1;
                }
                if (preloadOrder) {
                    preLoad();
                }
            }

            //Wait for the next digest cycle for the page to render so onChange events can trigger
            $timeout(function () {
                getGenericData();
            }, 0);

            if (vm.isScheduled) {
                vm.orden.orderProgramada = true;
                vm.dates.orden = null;
            }

        })();

        $scope.$on('checkExitAction' + vm.tab.state, function (event, args) {
            simpleModalService.showConfirmCloseModal(doSave, vm.tab, function (t) {
                vm.tab.closeAction();
            });
        });

        $scope.$watchGroup(['vm.orden.orderLatRec', 'vm.orden.orderLongRec',
            'vm.orden.orderLatEnt', 'vm.orden.orderLongEnt',
            'vm.genericData.bases.selectedSalida.latitud',
            'vm.genericData.bases.selectedSalida.longitud'],
            calculateDistance
        );

        $scope.$watch('orderForm.$dirty', function (isDirty) {
            vm.tab.modified = isDirty;
        });

        $scope.$watch('vm.orden.orderEstado', function (orderEstado) {
            vm.assignmentDataMustShowVehicleAndOperator = orderEstado >= 10;
        });

        function callRetarifar() {
            if (!checkValorarRetarifar()) {
                return;
            }
            simpleModalService.yesNoModal('Confirmación valorar', '¿Desea valorar la orden?')
                .then(function (result) {
                    if (result) {
                        if (vm.isNewOrder) {
                            vm.isNewOrder = false;
                            vm.savedToRetarifar = true;
                            save();
                        }
                        else {
                            doRetarifar();
                        }
                    }
                });
        }

        function doRetarifar() {
            ordersService.retarifar(orderId)
                .then(function (res) {
                    assingValoracionData(res.data.d);
                    getLineasImpuesto(orderId);
                    ordersService.getOrdenLineas(orderId)
                        .then(function (res) {
                            vm.lineasOrden = res.data;
                            //console.log(res);
                        });
                });
        }


        /* FUNCTION DEFINITIONS */
        function isEditar() {
            return orderId != null;
        }

        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }

        function getPathFrom() {
            var path = window.location.href;
            var res = path.split('/');
            vm.from = res[res.length - 1];
        }

        function addObservacion(obs, type) {
            if (!obs.add) {
                return;
            }
            obs.list.push({
                text: obs.add, time: Date.now(),
                author: userService.userData.name ? userService.userData.name : '' +
                    (userService.userData.surname ? ' ' + userService.userData.surname : '')
            });
            obs.add = null;

            if (type === 'obs') {
                vm.orden.orderObs = JSON.stringify(vm.observaciones.obs.list);
            } else if (type === 'int') {
                vm.orden.orderObsInt = JSON.stringify(vm.observaciones.internas.list);
            } else if (type === 'cli') {
                vm.orden.orderObsCliente = JSON.stringify(vm.observaciones.cliente.list);
            }
        }

        function save() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }

            if (!validate()) {
                return;
            }

            doSave().then(function (data) {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                $rootScope.$broadcast('ReloadOrdenesProgramadas');
                $rootScope.$broadcast('ReloadOrdenes');

                vm.tab.modified = false;
                if (!vm.orden.orderId) {
                    $state.go('flota.ordenes.editar', { 'id': data.data, 'accion': 'save' });
                }
            });
        }

        function saveAndClose() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y cerrar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }

            if (!validate()) {
                return;
            }

            doSave().then(function () {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                $rootScope.$broadcast('ReloadOrdenesProgramadas');
                $rootScope.$broadcast('ReloadOrdenes');

                vm.tab.modified = false;
                volverListado();
                $rootScope.tabManager.removeByStateName($state.$current.name);
            });
        }

        function saveAndNew() {

            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }

            if (!validate()) {
                return;
            }

            doSave().then(function () {
                $rootScope.$broadcast('ReloadOrdenesActivas');
                $rootScope.$broadcast('ReloadOrdenesProgramadas');
                $rootScope.$broadcast('ReloadOrdenes');

                vm.tab.modified = false;
                if (!vm.orden.orderId) {
                    $state.reload();
                } else {
                    $state.go('flota.ordenes.nueva', { 'accion': 'saveAndNew' });
                }
            });
        }

        function doSave() {

            var deferred = $q.defer();

            /* jshint maxcomplexity:false */
            vm.orden.empresaId = vm.genericData.empresas.selected.id;
            vm.orden.clienteId = vm.genericData.clients.selected.id;
            //Datos solicitante
            vm.orden.orderTipoOrdenId = vm.genericData.tiposOrden.selected.id;
            vm.orden.colectivoAsegId = vm.genericData.colectivos.selected.id;
            vm.orden.tipoSubFlotaId = vm.genericData.tiposSubFlota.selected.id;
            //Datos vehiculo
            vm.orden.orderGruMarcaId = vm.genericData.vehicleBrands.selected.id;
            vm.orden.orderGruMarca = vm.genericData.vehicleBrands.selected.nombre;
            vm.orden.orderGruModeloId = vm.genericData.vehicleModels.selected.id;
            vm.orden.orderGruModelo = vm.genericData.vehicleModels.selected.nombre;
            vm.orden.orderGruColor = vm.genericData.vehicleColors.selected.nombre;
            vm.orden.tipoVhcId = vm.genericData.tiposVehiculo.selected.id;
            //Datos asegurado
            vm.orden.orderGruPaisAseg = vm.genericData.paises.selectedAseg.nombre;
            vm.orden.orderGruProvAseg = vm.genericData.provinces.aseg.selected.nombre;
            vm.orden.orderGruPobAseg = vm.genericData.poblaciones.aseg.selected.nombre;
            //Datos incidente
            vm.orden.tipoIncId = vm.genericData.tiposIncidencia.selected.id;
            vm.orden.averiaId = vm.genericData.averias.default.selected.id;
            //Recogida
            vm.orden.orderGruTipoRec = vm.genericData.tiposRecogida.selected.id;
            vm.orden.tallerRecName = null;
            vm.orden.tallerRecId = null;
            vm.orden.baseRecId = null;
            vm.orden.colabRecId = null;
            if (vm.genericData.tiposRecogida.selected.id === 'B') {
                vm.orden.baseRecId = vm.genericData.bases.selectedRec.id;
            } else if (vm.genericData.tiposRecogida.selected.id === 'T') {
                vm.orden.tallerRecName = vm.genericData.talleres.selectedRec.nombre;
                vm.orden.tallerRecId = vm.genericData.talleres.selectedRec.id;
            } else if (vm.genericData.tiposRecogida.selected.id === 'C') {
                vm.orden.colabRecId = vm.genericData.colaboradores.selectedRec.id;
            }

            vm.orden.orderPaisRecId = vm.genericData.paises.selectedRec.id;
            vm.orden.orderPaisRec = vm.genericData.paises.selectedRec.desc;
            vm.orden.orderProvRecId = vm.genericData.provinces.selectedRec.id;
            vm.orden.orderProvRec = vm.genericData.provinces.selectedRec.desc;
            vm.orden.orderPobRecId = vm.genericData.poblaciones.selectedRec.id;
            vm.orden.orderPobRec = vm.genericData.poblaciones.selectedRec.desc;

            vm.orden.orderPaisEntId = vm.genericData.paises.selectedEnt.id;
            vm.orden.orderPaisEnt = vm.genericData.paises.selectedEnt.desc;
            vm.orden.orderProvEntId = vm.genericData.provinces.selectedEnt.id;
            vm.orden.orderProvEnt = vm.genericData.provinces.selectedEnt.desc;
            vm.orden.orderPobEntId = vm.genericData.poblaciones.selectedEnt.id;
            vm.orden.orderPobEnt = vm.genericData.poblaciones.selectedEnt.desc;

            vm.orden.orderCpRec = vm.orden.orderCpRec ? vm.orden.orderCpRec.substring(0, 5) : vm.orden.orderCpRec;
            //Entrega
            vm.orden.orderGruTipoEnt = vm.genericData.tiposEntrega.selected.id;
            vm.orden.tallerEntName = null;
            vm.orden.tallerEntId = null;
            vm.orden.baseEntId = null;
            vm.orden.colabEntId = null;
            if (vm.genericData.tiposEntrega.selected.id === 'B') {
                vm.orden.baseEntId = vm.genericData.bases.selectedEnt.id;
            } else if (vm.genericData.tiposEntrega.selected.id === 'T') {
                vm.orden.tallerEntName = vm.genericData.talleres.selectedEnt.nombre;
                vm.orden.tallerEntId = vm.genericData.talleres.selectedEnt.id;
            } else if (vm.genericData.tiposEntrega.selected.id === 'C') {
                vm.orden.colabEntId = vm.genericData.colaboradores.selectedEnt.id;
            }

            vm.orden.orderCpEnt = vm.orden.orderCpEnt ? vm.orden.orderCpEnt.substring(0, 5) : vm.orden.orderCpEnt;
            //Panel Salida
            vm.orden.baseSalidaId = vm.genericData.bases.selectedSalida.id;
            //Datos asignacion
            vm.orden.operarioId = vm.genericData.operarios.selected.id;
            vm.orden.flotaId = vm.genericData.vehiculos.selected.id;
            vm.orden.colaboradorId = vm.genericData.colaboradores.selectedAssignmentData.id;
            //Datos finalizacion
            vm.orden.tipoFinId = vm.genericData.tiposFin.selected.id;
            vm.orden.orderGruNocFes = vm.genericData.nocFes.selected.id;
            vm.orden.tipoIncFinId = vm.genericData.tiposIncidencia.selectedFin.id;
            vm.orden.averiaFinId = vm.genericData.averias.fin.selected.id;

            vm.orden.tipoPagoId = vm.genericData.formasPago.selected.id;

            vm.orden.orderDate = vm.dates.orden;
            vm.orden.orderFechaAlta = vm.dates.alta;
            vm.orden.orderFechaAsig = vm.dates.asignacion;
            vm.orden.orderFechaEnt = vm.dates.entrega;
            vm.orden.orderFechaFin = vm.dates.finalizado;
            vm.orden.orderFechaAcep = vm.dates.aceptado;
            vm.orden.orderFechaIni = vm.dates.inicio;
            vm.orden.orderFechaLoc = vm.dates.localizacion;
            vm.orden.orderFechaLimiteEnt = vm.dates.entPrev;
            vm.orden.orderFechaLocPrev = vm.dates.recPrev;

            vm.doingSomething = true;
            if (vm.orden.orderId != null) {
                //Service call to update order
                ordersService.saveOrder(vm.orden, vm.orden.orderId).then(
                    function (data) { //CALLBACKS
                        notificationService.sendAppNotification({
                            message: 'Orden modificada con éxito',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                        vm.doingSomething = false;
                        deferred.resolve(data);
                    }, function (data) {
                        notificationService.sendAppNotification({
                            message: 'Ha ocurrido un error al modificar la orden',
                            positionY: 'top', positionX: 'right', delay: null, type: 'error'
                        });
                        vm.doingSomething = false;
                        deferred.reject(data);
                    }
                );
            } else {
                //Service call to add order
                ordersService.addOrder(vm.orden).then(
                    function (data) { //CALLBACKS
                        notificationService.sendAppNotification({
                            message: 'Orden creada con éxito',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                        vm.doingSomething = false;
                        if (vm.savedToRetarifar) {
                            vm.savedToRetarifar = false;
                            doRetarifar();
                        }
                        deferred.resolve(data);
                    }, function (data) {
                        notificationService.sendAppNotification({
                            message: 'Ha ocurrido un error al crear la orden',
                            positionY: 'top', positionX: 'right', delay: null, type: 'error'
                        });
                        vm.doingSomething = false;
                        deferred.reject(data);
                    }
                );
            }

            return deferred.promise;
        }

        function remove() {
            if (orderId == null) { return; }

            simpleModalService.yesNoModal('Confirmación eliminar', '¿Desea eliminar la orden?')
                .then(function (result) {
                    if (result) {
                        notificationService.sendAppNotification({
                            message: 'Eliminando orden...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.removeOrders([vm.orden.orderId]).then(function () {
                            notificationService.sendAppNotification({
                                message: 'Orden eliminada con éxito',
                                positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                            });

                            vm.tab.modified = false;
                            volverListado();
                        }, function () {
                            notificationService.sendAppNotification({
                                message: 'Ha ocurrido un error al eliminar la orden',
                                positionY: 'top', positionX: 'right',
                                delay: null, type: 'error'
                            });
                        });
                    }
                });
        }

        function print() {
            //TODO: print
            /*
            var printContents = document.getElementById(divName).innerHTML;
            var popupWin = window.open('', '_blank', 'width=800,height=800');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="invesfleet.css" />
            </head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
            */
        }

        function addImage(img, imgName) {
            vm.images.push({
                data: img,
                name: imgName
            });
        }

        function addLineaOrden() {
            if (!checkValorar()) { return; }
            if (!vm.lineasOrden) { vm.lineasOrden = []; }
            if (allValuesFull()) {
                var newJson = angular.extend(vm.linea,
                    {
                        ordenId: orderId,
                        productoId: vm.genericData.productos.selected.id,
                        tarifaId: vm.genericData.tarifas.selected.id,
                        LineaOrdenTotal: vm.linea.lineaOrdenTotal,
                        productoName: vm.genericData.productos.selected.nombre,
                        tarifaDesc: vm.genericData.tarifas.selected.nombre
                    });
                vm.lineasOrden.push(newJson);
                ordersService.saveOrdenLinea(newJson)
                    .then(function (result) {
                        //vm.genericData.tarifas.selected = null;
                        vm.genericData.productos.selected = null;
                        vm.linea = {};
                        vm.calcular();
                        ordersService.getOrdenLineas(orderId)
                            .then(function (res) {
                                vm.lineasOrden = res.data;
                            });
                    });
            }
        }

        function recalcularTotal() {
            if (!vm.linea) {
                return;
            }
            if (typeof vm.linea.lineaOrdenCantidad === 'undefined' || typeof vm.linea.lineaOrdenPrecio === 'undefined' || typeof vm.linea.lineaOrdenDescuento === 'undefined') {
                return;
            }

            vm.linea.lineaOrdenTotal = vm.linea.lineaOrdenCantidad * vm.linea.lineaOrdenPrecio -
                (vm.linea.lineaOrdenCantidad * vm.linea.lineaOrdenPrecio * vm.linea.lineaOrdenDescuento / 100);
        }

        function calcular() {
            ordersService.calcular(orderId, vm.orden.orderDescuento, vm.orden.orderSuplidosIncFac)
                .then(function (res) {
                    assingValoracionData(res.data.d);
                    getLineasImpuesto(orderId);
                });
        }

        function allValuesFull() {
            /*jshint maxcomplexity:false */
            if (vm.linea == null ||
                vm.genericData.tarifas.selected == null || vm.genericData.tarifas.selected.id == null ||
                vm.genericData.productos.selected == null || vm.genericData.productos.selected.id == null ||
                vm.linea.lineaOrdenDesc == null) {
                return false;
            }
            vm.linea.lineaOrdenCantidad = vm.linea.lineaOrdenCantidad ? vm.linea.lineaOrdenCantidad : 1;
            vm.linea.lineaOrdenPrecio = vm.linea.lineaOrdenPrecio ? vm.linea.lineaOrdenPrecio : 0;
            vm.linea.lineaOrdenDescuento = vm.linea.lineaOrdenDescuento ? vm.linea.lineaOrdenDescuento : 0;
            return true;
        }

        function removeLineaOrden(index) {
            var lineaOrdenId = vm.lineasOrden[index].lineaOrdenId;
            vm.lineasOrden.splice(index, 1);
            ordersService.removeOrdenLinea(lineaOrdenId)
                .then(function (result) {
                    //vm.linea = null;
                    vm.calcular();

                });
        }

        function assingValoracionData(info) {
            vm.orden.baseimponible = info.baseimponible;
            vm.orden.importeimpuestos = info.importeimpuestos;
            vm.orden.suplidos = info.suplidos;
            vm.orden.importebruto = info.importebruto;
            vm.orden.total = info.total;
            vm.orden.totalPresupuesto = info.totalPresupuesto;
            vm.orden.orderEstadoFac = info.estadofac;
        }

        function checkValorar() {
            if (vm.tab.modified) {
                alert('Hay cambios sin guardar, guarde la orden para valorar.');
                return false;
            } else if (!vm.genericData.clients.selected.id) {
                alert('No hay cliente seleccionado, seleccione uno para valorar.');
                return false;
            }
            return true;
        }

        function checkValorarRetarifar() {
            if (!vm.genericData.clients.selected.id) {
                alert('No hay cliente seleccionado, seleccione uno para valorar.');
                return false;
            }
            return true;
        }

        function changeStatus(status) {
            vm.orden.orderEstado = status;
        }

        function getStatusColor(status) {
            return vm.estado.colors[status] || 'undefined';
        }

        function showField(tipo, id) {
            if (id === null) { return false; }
            if (tipo === 'ent') {
                return $filter('filter')(vm.genericData.tiposEntrega.list, { id: id })[0].showField;
            } else {
                return $filter('filter')(vm.genericData.tiposRecogida.list, { id: id })[0].showField;
            }
        }

        function calculateDistance() {
            if (!vm.orden.orderLatRec ||
                !vm.orden.orderLongRec) {
                vm.orden.orderGruKmsCalculados = null;
                return;
            }
            var locRecogida = new google.maps.LatLng(vm.orden.orderLatRec, vm.orden.orderLongRec);

            if (vm.genericData.bases.selectedSalida &&
                vm.genericData.bases.selectedSalida.latitud &&
                vm.genericData.bases.selectedSalida.longitud) {
                var locSalida = new google.maps.LatLng(vm.genericData.bases.selectedSalida.latitud,
                    vm.genericData.bases.selectedSalida.longitud);

                var origenes = [locSalida, locRecogida];
                var destinos = [locRecogida, locSalida];

                if (vm.orden.orderLatEnt ||
                    vm.orden.orderLongEnt) {
                    var locEntrega = new google.maps.LatLng(vm.orden.orderLatEnt, vm.orden.orderLongEnt);

                    origenes = [locSalida, locRecogida, locEntrega];
                    destinos = [locRecogida, locEntrega, locSalida];
                }

                var service = new google.maps.DistanceMatrixService();
                service.getDistanceMatrix(
                    {
                        origins: origenes,
                        destinations: destinos,
                        travelMode: 'DRIVING'
                    }, setCalculatedDistance);

            } else {
                vm.orden.orderGruKmsCalculados = null;
            }
        }

        function setCalculatedDistance(response, status) {
            if (status !== 'OK') { return; }
            var distance = 0;

            for (var i = 0; i < response.rows.length; i++) {
                if (response.rows[i].elements[i].status === 'ZERO_RESULTS') {
                    vm.orden.orderGruKmsCalculados = null;
                    return;
                } else {
                    distance += response.rows[i].elements[i].distance.value;
                }
            }

            vm.orden.orderGruKmsCalculados = Math.round(distance / 1000 * 10) / 10;
            $scope.$apply();
        }

        //OnChange events for the selects and combos
        function onOrderDateChange() {
            if (vm.dates.orden === null) {
                vm.orden.orderProgramada = true;
                return;
            }

            var currentDate = Date.NewDate();
            var futureDate = new Date(currentDate.getTime() + (vm.tiempoDeProgramacion * 60 * 1000));

            if (vm.dates.orden > futureDate) {
                vm.orden.orderProgramada = true;
            } else {
                vm.orden.orderProgramada = false;
            }

            isValidFecha();
        }

        function onCompanyChange() {
            var c = vm.genericData.empresas.selected && vm.genericData.empresas.selected.id;
            getClients(c);
        }

        function onModelChange() {
            var model = findByProperty(vm.genericData.vehicleModels.list, 'id',
                vm.genericData.vehicleModels.selected.id);
            if (model) {
                var brand = findByProperty(vm.genericData.vehicleBrands.list, 'id', model.marcaId);
                vm.genericData.vehicleBrands.selected = brand;
            }
        }
        
        function onTipoFlotaChange() {
            var tf = vm.genericData.tiposFlota.selected && vm.genericData.tiposFlota.selected.id;
            if (tf) {
                vm.genericData.tiposSubFlota.list = $filter('filter')
                    (vm.genericData.tiposSubFlota.fullList, { tipoFlotaId: tf }, true);
                selectChanged(vm.genericData.tiposSubFlota.list, vm.genericData.tiposSubFlota.selected);
            } else {
                vm.genericData.tiposSubFlota.list = vm.genericData.tiposSubFlota.fullList;
                selectChanged(vm.genericData.tiposSubFlota.list, vm.genericData.tiposSubFlota.selected);
            }
        }

        function onTipoSubFlotaChange() {
            var tsf = findByProperty(vm.genericData.tiposSubFlota.list, 'id',
                vm.genericData.tiposSubFlota.selected.id);
            if (tsf) {
                var tf = { id: tsf.tipoFlotaId };
                if (vm.genericData.tiposFlota.list) {
                    tf = findByProperty(vm.genericData.tiposFlota.list, 'id', tsf.tipoFlotaId);
                }
                vm.genericData.tiposFlota.selected = tf;
            }
        }

        function onClientChange() {
            var client = vm.genericData.clients.selected && vm.genericData.clients.selected.id;
            //var paisEnt = vm.genericData.paises.selectedEnt && vm.genericData.paises.selectedEnt.id;
            //var paisRec = vm.genericData.paises.selectedRec && vm.genericData.paises.selectedRec.id;
            var paisAseg = vm.genericData.paises.selectedAseg && vm.genericData.paises.selectedAseg.id;
            var provEnt = vm.genericData.provinces.entrega.selected && vm.genericData.provinces.selectedEnt.id;
            var provRec = vm.genericData.provinces.recogida.selected && vm.genericData.provinces.selectedRec.id;
            var provAseg = vm.genericData.provinces.aseg.selected && vm.genericData.provinces.aseg.selected.id;
            //
            getTarifas(client);
            //getPaises(client);
            //getProvinciasEntrega(client, paisEnt);
            //getProvinciasRecogida(client, paisRec);
            getProvinciasAseg(client, paisAseg);
            //getPoblacionesEntrega(client, provEnt);
            //getPoblacionesRecogida(client, provRec);
            getPoblacionesAseg(client, provAseg);
            getColectivos(client);
            getTiposVhc(client);
            getTiposIncidencia(client);
            getTiposFin(client);

            if (needToRetarifar && vm.orden.orderEstadoFac >= 2) { //Está valorado

                if (!validate()) {
                    return;
                }

                doSave().then(function () {

                    $rootScope.$broadcast('ReloadOrdenesActivas');
                    $rootScope.$broadcast('ReloadOrdenesProgramadas');
                    $rootScope.$broadcast('ReloadOrdenes');

                    vm.tab.modified = false;
                    doRetarifar();
                });
                needToRetarifar = false;
            }

            // 
            setAddressSearcher(vm.genericData.clients.selected);
        }

        function onTarifaChange() {
            var tarifa = vm.genericData.tarifas.selected && vm.genericData.tarifas.selected.id;
            getProductos(tarifa);
            getProductoTarifas();
        }

        function onProductoChange() {
            getProductoTarifas();
        }

        function change() {
        }

        function onPaisRecChange() {
            if (vm.genericData.paises.selectedRec !== null && typeof vm.genericData.paises.selectedRec !== 'undefined' && vm.genericData.paises.selectedRec.disableOnChangeEvent) {
                return;
            }

            var data = vm.genericData.paises.selectedRec;
            if (data === null || typeof data === 'undefined' || data.desc === null || typeof data.desc === 'undefined') {
                return;
            }

            var evt = new CustomEvent(EVT_TYPE__PAIS_CHANGED, {
                detail: {
                    sender: 'rec',
                    data: data
                }
            });
            document.dispatchEvent(evt);
        }

        function onProvRecChange() {
            if (vm.genericData.provinces.selectedRec !== null && typeof vm.genericData.provinces.selectedRec !== 'undefined' && vm.genericData.provinces.selectedRec.disableOnChangeEvent) {
                return;
            }

            var data = vm.genericData.provinces.selectedRec;
            if (data === null || typeof data === 'undefined' || data.desc === null || typeof data.desc === 'undefined') {
                return;
            }

            var evt = new CustomEvent(EVT_TYPE__PROVINCIA_CHANGED, {
                detail: {
                    sender: 'rec',
                    data: data
                }
            });
            document.dispatchEvent(evt);
        }

        function onPobRecChange() {
            if (vm.genericData.poblaciones.selectedRec !== null && typeof vm.genericData.poblaciones.selectedRec !== 'undefined' && vm.genericData.poblaciones.selectedRec.disableOnChangeEvent) {
                return;
            }

            var data = vm.genericData.poblaciones.selectedRec;
            if (data === null || typeof data === 'undefined' || data.desc === null || typeof data.desc === 'undefined') {
                return;
            }

            var evt = new CustomEvent(EVT_TYPE__POBLACION_CHANGED, {
                detail: {
                    sender: 'rec',
                    data: data
                }
            });
            document.dispatchEvent(evt);
        }

        function onPaisEntChange() {
            if (vm.genericData.paises.selectedEnt !== null && typeof vm.genericData.paises.selectedEnt !== 'undefined' && vm.genericData.paises.selectedEnt.disableOnChangeEvent) {
                return;
            }

            var data = vm.genericData.paises.selectedEnt;
            if (data === null || typeof data === 'undefined' || data.desc === null || typeof data.desc === 'undefined') {
                return;
            }

            var evt = new CustomEvent(EVT_TYPE__PAIS_CHANGED, {
                detail: {
                    sender: 'ent',
                    data: data
                }
            });
            document.dispatchEvent(evt);
        }

        function onProvEntChange() {
            if (vm.genericData.provinces.selectedEnt !== null && typeof vm.genericData.provinces.selectedEnt !== 'undefined' && vm.genericData.provinces.selectedEnt.disableOnChangeEvent) {
                return;
            }

            var data = vm.genericData.provinces.selectedEnt;
            if (data === null || typeof data === 'undefined' || data.desc === null || typeof data.desc === 'undefined') {
                return;
            }

            var evt = new CustomEvent(EVT_TYPE__PROVINCIA_CHANGED, {
                detail: {
                    sender: 'ent',
                    data: data
                }
            });
            document.dispatchEvent(evt);
        }

        function onPobEntChange() {
            if (vm.genericData.poblaciones.selectedEnt !== null && typeof vm.genericData.poblaciones.selectedEnt !== 'undefined' && vm.genericData.poblaciones.selectedEnt.disableOnChangeEvent) {
                return;
            }

            var data = vm.genericData.poblaciones.selectedEnt;
            if (data === null || typeof data === 'undefined' || data.desc === null || typeof data.desc === 'undefined') {
                return;
            }

            var evt = new CustomEvent(EVT_TYPE__POBLACION_CHANGED, {
                detail: {
                    sender: 'ent',
                    data: data
                }
            });
            document.dispatchEvent(evt);
        }

        function onPaisAsegChange() {
            var client = vm.genericData.clients.selected && vm.genericData.clients.selected.id;
            var pais = vm.genericData.paises.selectedAseg && vm.genericData.paises.selectedAseg.id;
            getProvinciasAseg(client, pais);
        }

        function onProvAsegChange() {
            var cient = vm.genericData.clients.selected && vm.genericData.clients.selected.id;
            var prov = vm.genericData.provinces.aseg.selected && vm.genericData.provinces.aseg.selected.id;
            getPoblacionesAseg(cient, prov);
        }

        function onAveriaChange() {
            var client = vm.genericData.clients.selected && vm.genericData.clients.selected.id;
            var tiposIncidencia = vm.genericData.tiposIncidencia.selected && vm.genericData.tiposIncidencia.selected.id;
            getAverias(tiposIncidencia, client);
        }

        function onAveriaFinChange() {
            var client = vm.genericData.clients.selected && vm.genericData.clients.selected.id;
            var tiposIncidencia = vm.genericData.tiposIncidencia.selectedFin &&
                vm.genericData.tiposIncidencia.selectedFin.id;
            getAveriasFin(tiposIncidencia, client);
        }

        function onBaseRecSelected() {
            if (vm.genericData.clients.selected.hasCustomData) { return; }
            if (vm.orden.orderGruTipoRec === 'B' && !vm.skipBaseRec) { vm.skipBaseRec = true; return; }
            if (vm.genericData.tiposRecogida.selected.id !== 'B') { return; }
            var baseId = vm.genericData.bases.selectedRec && vm.genericData.bases.selectedRec.id;
            if (baseId === null || vm.genericData.bases.list === null) { return; }
            var base = $filter('filter')(vm.genericData.bases.list, { id: baseId })[0];
            if (base === null) { return; }

            bloodhoundSearchRec(base.poblacion, base.provincia, base.pais);

            vm.orden.orderCpRec = base.cp;
            vm.orden.orderDirRec = base.direccion;
            vm.orden.orderLatRec = base.latitud;
            vm.orden.orderLongRec = base.longitud;
            vm.orden.orderTfnoRec = base.telefono;
            vm.orden.dUbicacionRec = base.nombre;
        }

        function onBaseEntSelected() {
            if (vm.genericData.clients.selected.hasCustomData) { return; }
            if (vm.orden.orderGruTipoEnt === 'B' && !vm.skipBaseEnt) { vm.skipBaseEnt = true; return; }
            if (vm.genericData.tiposEntrega.selected.id !== 'B') { return; }
            var baseId = vm.genericData.bases.selectedEnt && vm.genericData.bases.selectedEnt.id;
            if (baseId === null || vm.genericData.bases.list === null) { return; }
            var base = $filter('filter')(vm.genericData.bases.list, { id: baseId })[0];
            if (base === null) { return; }

            bloodhoundSearchEnt(base.poblacion, base.provincia, base.pais);

            vm.orden.orderCpEnt = base.cp;
            vm.orden.orderDirEnt = base.direccion;
            vm.orden.orderLatEnt = base.latitud;
            vm.orden.orderLongEnt = base.longitud;
            vm.orden.orderTfnoEnt = base.telefono;
            vm.orden.dUbicacionEnt = base.nombre;
        }

        function onTallerEntSelected() {
            if (vm.genericData.clients.selected.hasCustomData) { return; }
            if (vm.orden.orderGruTipoEnt === 'T' && !vm.skipTallerEnt) { vm.skipTallerEnt = true; return; }
            if (vm.genericData.tiposEntrega.selected.id !== 'T') { return; }
            var tallerId = vm.genericData.talleres.selectedEnt && vm.genericData.talleres.selectedEnt.id;
            if (tallerId === null || vm.genericData.talleres.list === null) { return; }
            var taller = $filter('filter')(vm.genericData.talleres.list, { id: tallerId })[0];
            if (taller === null) { return; }

            bloodhoundSearchEnt(taller.poblacion, taller.provincia, taller.pais);

            vm.orden.orderCpEnt = taller.cp;
            vm.orden.orderDirEnt = taller.direccion;
            vm.orden.orderLatEnt = taller.latitud;
            vm.orden.orderLongEnt = taller.longitud;
            vm.orden.orderTfnoEnt = taller.telefono;
            vm.orden.dUbicacionEnt = taller.nombre;
        }

        function onTallerRecSelected() {
            if (vm.genericData.clients.selected.hasCustomData) { return; }
            if (vm.orden.orderGruTipoRec === 'T' && !vm.skipTallerRec) { vm.skipTallerRec = true; return; }
            if (vm.genericData.tiposRecogida.selected.id !== 'T') { return; }
            var tallerId = vm.genericData.talleres.selectedRec && vm.genericData.talleres.selectedRec.id;
            if (tallerId === null || vm.genericData.talleres.list === null) { return; }
            var taller = $filter('filter')(vm.genericData.talleres.list, { id: tallerId })[0];
            if (taller === null) { return; }

            bloodhoundSearchRec(taller.poblacion, taller.provincia, taller.pais);

            vm.orden.orderCpRec = taller.cp;
            vm.orden.orderDirRec = taller.direccion;
            vm.orden.orderLatRec = taller.latitud;
            vm.orden.orderLongRec = taller.longitud;
            vm.orden.orderTfnoRec = taller.telefono;
            vm.orden.dUbicacionRec = taller.nombre;
        }

        function onColabEntSelected() {
            if (vm.genericData.clients.selected.hasCustomData) { return; }
            if (vm.orden.orderGruTipoEnt === 'C' && !vm.skipColabEnt) { vm.skipColabEnt = true; return; }
            if (vm.genericData.tiposEntrega.selected.id !== 'C') { return; }
            var colabId = vm.genericData.colaboradores.selectedEnt && vm.genericData.colaboradores.selectedEnt.id;
            if (colabId === null || vm.genericData.colaboradores.list === null) { return; }
            var colab = $filter('filter')(vm.genericData.colaboradores.list, { id: colabId })[0];
            if (colab === null) { return; }

            //vm.genericData.paises.selectedEnt = { id: null, nombre: colab.pais };
            vm.genericData.provinces.entrega.selected = { id: null, nombre: colab.provincia };
            vm.genericData.poblaciones.entrega.selected = { id: null, nombre: colab.poblacion };
            vm.orden.orderCpEnt = colab.cp;
            vm.orden.orderDirEnt = colab.direccion;
            vm.orden.orderLatEnt = colab.latitud;
            vm.orden.orderLongEnt = colab.longitud;
            vm.orden.orderTfnoEnt = colab.telefono;
            vm.orden.dUbicacionEnt = colab.nombre;
        }

        function onColabRecSelected() {
            if (vm.genericData.clients.selected.hasCustomData) { return; }
            if (vm.orden.orderGruTipoRec === 'C' && !vm.skipColabRec) { vm.skipColabRec = true; return; }
            if (vm.genericData.tiposRecogida.selected.id !== 'C') { return; }
            var colabId = vm.genericData.colaboradores.selectedRec && vm.genericData.colaboradores.selectedRec.id;
            if (colabId === null || vm.genericData.colaboradores.list === null) { return; }
            var colab = $filter('filter')(vm.genericData.colaboradores.list, { id: colabId })[0];
            if (colab === null) { return; }

            vm.genericData.paises.selectedRec = { id: null, nombre: colab.pais };
            vm.genericData.provinces.recogida.selected = { id: null, nombre: colab.provincia };
            vm.genericData.poblaciones.recogida.selected = { id: null, nombre: colab.poblacion };
            vm.orden.orderCpRec = colab.cp;
            vm.orden.orderDirRec = colab.direccion;
            vm.orden.orderLatRec = colab.latitud;
            vm.orden.orderLongRec = colab.longitud;
            vm.orden.orderTfnoRec = colab.telefono;
            vm.orden.dUbicacionRec = colab.nombre;
        }

        //CALLBACKS
        vm.addColorCallback = addColorCallback;
        function addColorCallback() {
            vm.genericData.vehicleColors.loading = true;
            genericDataService.getVehicleColors(true)
                .then(function (res) {
                    vm.genericData.vehicleColors.loading = false;
                    vm.genericData.vehicleColors.list = res;
                    selectChanged(vm.genericData.vehicleColors.list, vm.genericData.vehicleColors.selected, false);
                });
        }

        vm.addClientCallback = addClientCallback;
        function addClientCallback(clienteId) {
            vm.genericData.clients.loading = true;
            genericDataService.getClients(vm.genericData.empresas.selected.id, true)
                .then(function (res) {
                    vm.genericData.clients.loading = false;
                    vm.genericData.clients.list = res;
                    vm.genericData.clients.selected = { id: clienteId, nombre: null };
                    selectChanged(vm.genericData.clients.list, vm.genericData.clients.selected);
                });
        }

        vm.showAddClient = showAddClient;
        function showAddClient() {
            modals.showModal('clients', vm.addClientCallback, vm.genericData.empresas.selected.id);
        }

        //MODAL
        function showDirectionsModal() {
            ModalService.showModal({
                template: modalTemplate,
                controller:
                function ($scope, close) {
                    $scope.vm = vm;
                    $scope.googleApiURL = endPoints.GOOGLE_MAPS_API_URL;

                    (function () {
                        NgMap.getMap('mapDirections').then(function (map) {
                            $scope.google.maps.event.trigger(map, 'resize');

                            map.directionsRenderers[0].panel = document.getElementById('directions-panel');
                            if (vm.genericData.bases.selectedSalida && vm.genericData.bases.selectedSalida.latitud &&
                                vm.genericData.bases.selectedSalida.longitud) {
                                $scope.origin = {
                                    lat: vm.genericData.bases.selectedSalida.latitud,
                                    lng: vm.genericData.bases.selectedSalida.longitud
                                };

                                $scope.destination = $scope.origin;
                                if (vm.orden.orderLatEnt && vm.orden.orderLongEnt) {
                                    $scope.wayPoints = [
                                        {
                                            location: { lat: vm.orden.orderLatRec, lng: vm.orden.orderLongRec },
                                            stopover: true
                                        },
                                        {
                                            location: { lat: vm.orden.orderLatEnt, lng: vm.orden.orderLongEnt },
                                            stopover: true
                                        }
                                    ];
                                }
                                else {
                                    $scope.wayPoints = [
                                        {
                                            location: { lat: vm.orden.orderLatRec, lng: vm.orden.orderLongRec },
                                            stopover: true
                                        }
                                    ];
                                }
                            } else {
                                $scope.origin = { lat: vm.orden.orderLatRec, lng: vm.orden.orderLongRec };
                                $scope.destination = { lat: vm.orden.orderLatEnt, lng: vm.orden.orderLongEnt };
                                $scope.wayPoints = [];
                            }

                            $scope.map.directionsRenderers[0].addListener('directions_changed', function () {
                                $scope.duration = $scope.getTotalDuration();
                                $scope.distance = $scope.getTotalDistance();
                            });
                        });
                    })();

                    $scope.duration = 0;
                    $scope.distance = 0;


                    $scope.getTotalDistance = function () {
                        var myroute = null;
                        try { myroute = $scope.map.directionsRenderers[0].directions.routes[0]; }
                        catch (err) { return; }
                        if (!myroute) { return; }

                        var total = 0;
                        for (var i = 0; i < myroute.legs.length; i++) {
                            total += myroute.legs[i].distance.value;
                        }
                        total = total / 1000;
                        return Math.round(total * 10) / 10;
                    };

                    $scope.getTotalDuration = function () {
                        var myroute = null;
                        try { myroute = $scope.map.directionsRenderers[0].directions.routes[0]; }
                        catch (err) { return; }
                        if (!myroute) { return; }

                        var total = 0;
                        for (var i = 0; i < myroute.legs.length; i++) {
                            total += myroute.legs[i].duration.value;
                        }
                        return total;
                    };

                    $scope.cancel = function () {
                        $rootScope.blurry = false;
                        close();
                    };
                }
            });
        }

        var lastEntDir = null;
        function onEntDirChange() {
            if (lastEntDir === null) { lastEntDir = vm.orden.orderDirEnt; }

            if (vm.orden.dUbicacionEnt === undefined || vm.orden.dUbicacionEnt === null ||
                vm.orden.dUbicacionEnt === '' || vm.orden.dUbicacionEnt === lastEntDir) {
                vm.orden.dUbicacionEnt = vm.orden.orderDirEnt;
            }

            lastEntDir = vm.orden.orderDirEnt;
        }

        var lastRecDir = null;
        function onRecDirChange() {
            if (lastRecDir === null) { lastRecDir = vm.orden.orderDirRec; }

            if (vm.orden.dUbicacionRec === undefined || vm.orden.dUbicacionRec === null ||
                vm.orden.dUbicacionRec === '' || vm.orden.dUbicacionRec === lastRecDir) {
                vm.orden.dUbicacionRec = vm.orden.orderDirRec;
            }

            lastRecDir = vm.orden.orderDirRec;
        }

        function setDemoraConf() {
            if (vm.orden.ordenTipo !== 1) { return; }
            var demora = vm.dates.recPrev - vm.dates.orden;
            vm.orden.orderDemoraPrevista = Math.round(demora / (1000 * 60)); //To mins
        }

        function onRecAddressChange(address) {
            vm.orden.orderCpRec = address.cp;
            bloodhoundSearchRec(address.city, address.state, address.country);
        }

        function onEntAddressChange(address) {
            vm.orden.orderCpEnt = address.cp;
            bloodhoundSearchEnt(address.city, address.state, address.country);
        }

        function bloodhoundSearchRec(poblacion, provincia, pais) {
            if (pais !== null && typeof pais !== 'undefined' && vm.bloodhoundPaises !== null && typeof vm.bloodhoundPaises !== 'undefined') {
                vm.bloodhoundPaises.search(pais, function (data) {
                    if (data !== null && typeof data !== 'undefined' && data.length == 1) {
                        vm.genericData.paises.selectedRec = data[0];
                    } else {
                        vm.genericData.paises.selectedRec.id = null;
                        vm.genericData.paises.selectedRec.desc = pais.toUpperCase();
                    }
                    vm.genericData.paises.selectedRec.disableOnChangeEvent = true;
                });
            }

            if (provincia !== null && typeof provincia !== 'undefined' && vm.bloodhoundProvincias !== null && typeof vm.bloodhoundProvincias !== 'undefined') {
                vm.bloodhoundProvincias.search(provincia, function (data) {
                    if (data !== null && typeof data !== 'undefined' && data.length == 1) {
                        vm.genericData.provinces.selectedRec = data[0];
                    } else {
                        vm.genericData.provinces.selectedRec.id = null;
                        vm.genericData.provinces.selectedRec.desc = provincia.toUpperCase();
                    }
                    vm.genericData.provinces.selectedRec.disableOnChangeEvent = true;
                });
            }

            if (poblacion !== null && typeof poblacion !== 'undefined' && vm.bloodhoundPoblaciones !== null && typeof vm.bloodhoundPoblaciones !== 'undefined') {
                vm.bloodhoundPoblaciones.search(poblacion, function (data) {
                    if (data !== null && typeof data !== 'undefined' && data.length == 1) {
                        vm.genericData.poblaciones.selectedRec = data[0];
                    } else {
                        vm.genericData.poblaciones.selectedRec.id = null;
                        vm.genericData.poblaciones.selectedRec.desc = poblacion.toUpperCase();
                    }
                    vm.genericData.poblaciones.selectedRec.disableOnChangeEvent = true;
                });
            }
        }

        function bloodhoundSearchEnt(poblacion, provincia, pais) {

            if (pais !== null && typeof pais !== 'undefined' && vm.bloodhoundPaises !== null && typeof vm.bloodhoundPaises !== 'undefined') {
                vm.bloodhoundPaises.search(pais, function (data) {
                    if (data !== null && typeof data !== 'undefined' && data.length == 1) {
                        vm.genericData.paises.selectedEnt = data[0];
                    } else {
                        vm.genericData.paises.selectedEnt.id = null;
                        vm.genericData.paises.selectedEnt.desc = pais.toUpperCase();
                    }
                    vm.genericData.paises.selectedEnt.disableOnChangeEvent = true;
                });
            }

            if (provincia !== null && typeof provincia !== 'undefined' && vm.bloodhoundProvincias !== null && typeof vm.bloodhoundProvincias !== 'undefined') {
                vm.bloodhoundProvincias.search(provincia, function (data) {
                    if (data !== null && typeof data !== 'undefined' && data.length == 1) {
                        vm.genericData.provinces.selectedEnt = data[0];
                    } else {
                        vm.genericData.provinces.selectedEnt.id = null;
                        vm.genericData.provinces.selectedEnt.desc = provincia.toUpperCase();
                    }
                    vm.genericData.provinces.selectedEnt.disableOnChangeEvent = true;
                });
            }

            if (poblacion !== null && typeof poblacion !== 'undefined' && vm.bloodhoundPoblaciones !== null && typeof vm.bloodhoundPoblaciones !== 'undefined') {
                vm.bloodhoundPoblaciones.search(poblacion, function (data) {
                    if (data !== null && typeof data !== 'undefined' && data.length == 1) {
                        vm.genericData.poblaciones.selectedEnt = data[0];
                    } else {
                        vm.genericData.poblaciones.selectedEnt.id = null;
                        vm.genericData.poblaciones.selectedEnt.desc = poblacion.toUpperCase();
                    }
                    vm.genericData.poblaciones.selectedEnt.disableOnChangeEvent = true;
                });
            }
        }


        /* PRIVATE FUNCTIONS */
        // Method to get the static data that doesnt depend on anything (we dont have to wait for the order info)
        function getGenericData() {

            vm.genericData.empresas.loading = true;
            genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.loading = false;
                    vm.genericData.empresas.list = res;
                    selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected);

                    if (vm.genericData.empresas.selected.id == null && defaultVal.empresa) {
                        vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
                        //defaultVal.empresa = false;
                    }
                });

            vm.genericData.vehicleBrands.loading = true;
            genericDataService.getVehicleBrands()
                .then(function (res) {
                    vm.genericData.vehicleBrands.loading = false;
                    vm.genericData.vehicleBrands.list = res;
                    selectChanged(vm.genericData.vehicleBrands.list, vm.genericData.vehicleBrands.selected, false);
                });


            vm.genericData.vehicleModels.loading = true;
            genericDataService.getVehicleModel()
                .then(function (res) {
                    vm.genericData.vehicleModels.loading = false;
                    vm.genericData.vehicleModels.fullList = res;
                    vm.genericData.vehicleModels.list = res;
                    selectChanged(vm.genericData.vehicleModels.list, vm.genericData.vehicleModels.selected, false);
                });

            vm.genericData.tiposSubFlota.loading = true;
            genericDataService.getTiposSubFlota()
                .then(function (res) {
                    vm.genericData.tiposSubFlota.loading = false;
                    vm.genericData.tiposSubFlota.list = res;
                    vm.genericData.tiposSubFlota.fullList = res;
                    selectChanged(vm.genericData.tiposSubFlota.list, vm.genericData.tiposSubFlota.selected);
                    //vm.onTipoSubFlotaChange();
                    if (vm.genericData.tiposSubFlota.selected.id == null && defaultVal.tipoFlota) {
                        if (preferences.prefs.sector === 'TAX') {
                            var def = 'TAXI';
                            var tipoFlota = findByProperty(vm.genericData.tiposSubFlota.list, 'nombre', def);
                            if (tipoFlota !== null) {
                                vm.genericData.tiposSubFlota.selected = tipoFlota;
                            }
                        }
                    }
                });

            vm.genericData.tiposFlota.loading = true;
            genericDataService.getTiposFlota()
                .then(function (res) {
                    vm.genericData.tiposFlota.loading = false;
                    vm.genericData.tiposFlota.list = res;
                    selectChanged(vm.genericData.tiposFlota.list, vm.genericData.tiposFlota.selected);

                    if (vm.genericData.tiposFlota.selected.id == null && defaultVal.tipoFlota) {
                        var def = 'Grúa';
                        if (preferences.prefs.sector === 'TAX') { def = 'Taxi'; }
                        var tipoFlota = findByProperty(vm.genericData.tiposFlota.list, 'nombre', def);
                        if (tipoFlota !== null) {
                            vm.genericData.tiposFlota.selected = tipoFlota;
                        }
                        //defaultVal.tipoFlota = false;
                    }
                });

            vm.genericData.vehicleColors.loading = true;
            genericDataService.getVehicleColors()
                .then(function (res) {
                    vm.genericData.vehicleColors.loading = false;
                    vm.genericData.vehicleColors.list = res;
                    selectChanged(vm.genericData.vehicleColors.list, vm.genericData.vehicleColors.selected, false);
                });

            vm.genericData.bases.loading = true;
            genericDataService.getBases()
                .then(function (res) {
                    vm.genericData.bases.loading = false;
                    vm.genericData.bases.list = res;
                    selectChanged(vm.genericData.bases.list, vm.genericData.bases.selectedSalida);
                    selectChanged(vm.genericData.bases.list, vm.genericData.bases.selectedEnt);
                    selectChanged(vm.genericData.bases.list, vm.genericData.bases.selectedRec);
                    vm.onBaseEntSelected();
                    vm.onBaseRecSelected();

                    if (vm.genericData.bases.selectedSalida.id == null && defaultVal.baseSal) {
                        var base = vm.genericData.bases.list[0];
                        if (base !== null) {
                            vm.genericData.bases.selectedSalida = base;
                        }
                        //defaultVal.baseSal = false;
                    }
                });

            vm.genericData.talleres.loading = true;
            genericDataService.getTalleres()
                .then(function (res) {
                    vm.genericData.talleres.loading = false;
                    vm.genericData.talleres.list = res;
                    selectChanged(vm.genericData.talleres.list, vm.genericData.talleres.selectedEnt);
                    selectChanged(vm.genericData.talleres.list, vm.genericData.talleres.selectedRec);
                    vm.onTallerEntSelected();
                    vm.onTallerRecSelected();
                });

            vm.genericData.colaboradores.loading = true;
            genericDataService.getColaboradores()
                .then(function (res) {
                    vm.genericData.colaboradores.loading = false;
                    vm.genericData.colaboradores.list = res;
                    selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedEnt);
                    selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedRec);
                    selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedAssignmentData);
                    vm.onColabEntSelected();
                    vm.onColabRecSelected();
                });
            
            vm.genericData.operarios.loading = true;
            genericDataService.getOperarios()
                .then(function (res) {
                    vm.genericData.operarios.loading = false;
                    vm.genericData.operarios.list = res;
                    selectChanged(vm.genericData.operarios.list, vm.genericData.operarios.selected);
                });
            
            vm.genericData.vehiculos.loading = true;
            genericDataService.getFlota()
                .then(function (res) {
                    vm.genericData.vehiculos.loading = false;
                    vm.genericData.vehiculos.list = res;
                    selectChanged(vm.genericData.vehiculos.list, vm.genericData.vehiculos.selected);
                });

            vm.genericData.formasPago.loading = true;
            genericDataService.getTiposPago()
                .then(function (res) {
                    vm.genericData.formasPago.loading = false;
                    vm.genericData.formasPago.list = res;
                    selectChanged(vm.genericData.formasPago.list, vm.genericData.formasPago.selected);
                });

            vm.genericData.tiposOrden.loading = true;
            genericDataService.getTiposOrden()
                .then(function (res) {
                    vm.genericData.tiposOrden.loading = false;
                    vm.genericData.tiposOrden.list = res;
                    selectChanged(vm.genericData.tiposOrden.list, vm.genericData.tiposOrden.selected);
                });
        }

        // Get the clients -> DEPENDS ON: company
        function getClients(company) {
            if (company == null) { vm.genericData.clients.list = null; }
            else {
                vm.genericData.clients.loading = true;
                genericDataService.getClients(company)
                    .then(function (res) {
                        vm.genericData.clients.loading = false;
                        vm.genericData.clients.list = res;
                        selectChanged(vm.genericData.clients.list, vm.genericData.clients.selected);
                    });
            }
        }

        function getTarifas(clientId) {
            if (clientId == null) {
                vm.genericData.tarifas.list = null;
                vm.genericData.tarifas.selected = { id: null, nombre: null };
                return;
            }
            var type = vm.orden.orderTipo === 0 ? 'GRU' : 'LOG';
            if (preferences.prefs.sector === 'TAX') { type = 'TAX'; }
            vm.genericData.tarifas.loading = true;
            genericDataService.getTarifas(clientId, type)
                .then(function (res) {
                    vm.genericData.tarifas.loading = false;
                    vm.genericData.tarifas.list = res;
                    selectChanged(vm.genericData.tarifas.list, vm.genericData.tarifas.selected);
                });
        }

        function getProductos(tarifaId) {
            if (tarifaId == null) {
                vm.genericData.productos.list = null;
                vm.genericData.productos.selected = { id: null, nombre: null };
                return;
            }
            vm.genericData.productos.loading = true;
            genericDataService.getProductos(tarifaId)
                .then(function (res) {
                    vm.genericData.productos.loading = false;
                    vm.genericData.productos.list = res;
                    selectChanged(vm.genericData.productos.list, vm.genericData.productos.selected);
                });
        }

        function setAddressSearcher(client) {

            vm.genericData.paises.loading = true;
            vm.genericData.provinces.entrega.loading = true;
            vm.genericData.provinces.recogida.loading = true;
            vm.genericData.poblaciones.entrega.loading = true;
            vm.genericData.poblaciones.recogida.loading = true;

            var cid = (client !== null) ? client.id : null;
            genericDataService.getAddressSearcherData(cid)
                .then(function (result) {
                    if (result) {
                        var loadPoblaciones = true;
                        var loadProvincias = true;
                        var loadPaises = true;
                        if (currentAddressDb != null) {
                            loadPoblaciones = (currentAddressDb.urlPoblaciones !== result.urlPoblaciones);
                            loadProvincias = (currentAddressDb.urlProvincias !== result.urlProvincias);
                            loadPaises = (currentAddressDb.urlPaises !== result.urlPaises);
                        }
                        currentAddressDb = result;

                        if (loadPoblaciones) {
                            genericDataService.getAddressSearcherCache(result.urlPoblaciones)
                                .then(function (data) {
                                    vm.genericData.addressSearcherPoblaciones.list = data;
                                    //vm.bloodhoundPoblaciones.clear();
                                    vm.bloodhoundPoblaciones = new Bloodhound({
                                        initialize: true,
                                        local: data,
                                        datumTokenizer: Bloodhound.tokenizers.obj.nonword('desc'),
                                        queryTokenizer: Bloodhound.tokenizers.nonword,
                                        identify: function (obj) { return obj.id; },
                                    });

                                    vm.genericData.poblaciones.entrega.loading = false;
                                    vm.genericData.poblaciones.recogida.loading = false;
                                });
                        } else {
                            vm.genericData.poblaciones.entrega.loading = false;
                            vm.genericData.poblaciones.recogida.loading = false;
                        }

                        if (loadProvincias) {
                            genericDataService.getAddressSearcherCache(result.urlProvincias)
                                .then(function (data) {
                                    vm.genericData.addressSearcherProvincias.list = data;
                                    //vm.bloodhoundProvincias.clear();
                                    vm.bloodhoundProvincias = new Bloodhound({
                                        initialize: true,
                                        local: data,
                                        datumTokenizer: Bloodhound.tokenizers.obj.nonword('desc'),
                                        queryTokenizer: Bloodhound.tokenizers.nonword,
                                        identify: function (obj) { return obj.id + obj.idpa; },
                                    });

                                    vm.genericData.provinces.entrega.loading = false;
                                    vm.genericData.provinces.recogida.loading = false;
                                });
                        } else {
                            vm.genericData.provinces.entrega.loading = false;
                            vm.genericData.provinces.recogida.loading = false;
                        }

                        if (loadPaises) {
                            genericDataService.getAddressSearcherCache(result.urlPaises)
                                .then(function (data) {
                                    vm.genericData.addressSearcherPaises.list = data;
                                    //vm.bloodhoundPaises.clear();
                                    vm.bloodhoundPaises = new Bloodhound({
                                        initialize: true,
                                        local: data,
                                        datumTokenizer: Bloodhound.tokenizers.obj.nonword('desc'),
                                        queryTokenizer: Bloodhound.tokenizers.nonword,
                                        identify: function (obj) { return obj.id; },
                                    });

                                    vm.genericData.paises.loading = false;
                                });
                        } else {
                            vm.genericData.paises.loading = false;
                        }

                        //if (loadPaises || loadProvincias || loadPaises) {
                        //    clearAddress();
                        //} else
                        //{
                        //    if (!vm.isNewForm) {
                        //        bloodhoundSearchRec(vm.orden.orderPobRec, vm.orden.orderProvRec, vm.orden.orderPaisRec);
                        //        bloodhoundSearchEnt(vm.orden.orderPobEnt, vm.orden.orderProvEnt, vm.orden.orderPaisEnt);
                        //    }
                        //}                        
                    }
                });
        }

        function clearAddress() {
            vm.genericData.poblaciones.selectedRec = { disableOnChangeEvent: false };
            vm.genericData.provinces.selectedRec = { disableOnChangeEvent: false };
            vm.genericData.paises.selectedRec = { disableOnChangeEvent: false };

            vm.genericData.poblaciones.selectedEnt = { disableOnChangeEvent: false };
            vm.genericData.provinces.selectedEnt = { disableOnChangeEvent: false };
            vm.genericData.paises.selectedEnt = { disableOnChangeEvent: false };
        }

        // Get the country data -> DEPENDS ON: client
        function getPaises(clientId) {
            /*if(clientId == null){
                vm.genericData.paises.list = null;
                vm.genericData.paises.selectedEnt = { id: null, nombre: null };
                vm.genericData.paises.selectedRec = { id: null, nombre: null };
                return;
            }*/
            vm.genericData.paises.loading = true;
            genericDataService.getPaises(clientId)
                .then(function (res) {
                    vm.genericData.paises.loading = false;
                    vm.genericData.paises.list = res;
                    selectChanged(vm.genericData.paises.list, vm.genericData.paises.selectedEnt, false);
                    selectChanged(vm.genericData.paises.list, vm.genericData.paises.selectedRec, false);
                });
        }
        // Get the delivery provinces data -> DEPENDS ON: client, delivery country
        function getProvinciasEntrega(clientId, pais) {
            if (pais == null) {
                vm.genericData.provinces.entrega.list = null;
                if (vm.genericData.provinces.entrega.selected.id != null) {
                    vm.genericData.provinces.entrega.selected = { id: null, nombre: null };
                }
            } else {
                vm.genericData.provinces.entrega.loading = true;
                genericDataService.getProvinces(clientId, pais)
                    .then(function (res) {
                        vm.genericData.provinces.entrega.loading = false;
                        vm.genericData.provinces.entrega.list = res;
                        selectChanged(vm.genericData.provinces.entrega.list,
                            vm.genericData.provinces.entrega.selected, false);
                    });
            }
        }
        // Get the pickup provinces data -> DEPENDS ON: client, pickup country
        function getProvinciasRecogida(clientId, pais) {
            if (pais == null) {
                vm.genericData.provinces.recogida.list = null;
                if (vm.genericData.provinces.recogida.selected.id != null) {
                    vm.genericData.provinces.recogida.selected = { id: null, nombre: null };
                }
            } else {
                vm.genericData.provinces.recogida.loading = true;
                genericDataService.getProvinces(clientId, pais)
                    .then(function (res) {
                        vm.genericData.provinces.recogida.loading = false;
                        vm.genericData.provinces.recogida.list = res;
                        selectChanged(vm.genericData.provinces.recogida.list,
                            vm.genericData.provinces.recogida.selected, false);
                    });
            }
        }
        // Get the pickup provinces data -> DEPENDS ON: client, aseg country
        function getProvinciasAseg(clientId, pais) {
            if (pais == null) {
                vm.genericData.provinces.aseg.list = null;
                if (vm.genericData.provinces.aseg.selected.id != null) {
                    vm.genericData.provinces.aseg.selected = { id: null, nombre: null };
                }
            } else {
                vm.genericData.provinces.aseg.loading = true;
                genericDataService.getProvinces(clientId, pais)
                    .then(function (res) {
                        vm.genericData.provinces.aseg.loading = false;
                        vm.genericData.provinces.aseg.list = res;
                        selectChanged(vm.genericData.provinces.aseg.list,
                            vm.genericData.provinces.aseg.selected, false);
                    });
            }
        }
        // Get the delivery populations data -> DEPENDS ON: client, delivery province
        function getPoblacionesEntrega(clientId, provincia) {
            if (provincia == null) {
                vm.genericData.poblaciones.entrega.list = null;
                if (vm.genericData.poblaciones.entrega.selected.id != null) {
                    vm.genericData.poblaciones.entrega.selected = { id: null, nombre: null };
                }
            }
            else {
                vm.genericData.poblaciones.entrega.loading = true;
                genericDataService.getPopulations(clientId, provincia)
                    .then(function (res) {
                        vm.genericData.poblaciones.entrega.loading = false;
                        vm.genericData.poblaciones.entrega.list = res;
                        selectChanged(vm.genericData.poblaciones.entrega.list,
                            vm.genericData.poblaciones.entrega.selected, false);
                    });
            }
        }
        // Get the pickup populations data -> DEPENDS ON: client, pickup province
        function getPoblacionesRecogida(clientId, provincia) {
            if (provincia == null) {
                vm.genericData.poblaciones.recogida.list = null;
                if (vm.genericData.poblaciones.recogida.selected.id != null) {
                    vm.genericData.poblaciones.recogida.selected = { id: null, nombre: null };
                }
            } else {
                vm.genericData.poblaciones.recogida.loading = true;
                genericDataService.getPopulations(clientId, provincia)
                    .then(function (res) {
                        vm.genericData.poblaciones.recogida.loading = false;
                        vm.genericData.poblaciones.recogida.list = res;
                        selectChanged(vm.genericData.poblaciones.recogida.list,
                            vm.genericData.poblaciones.recogida.selected, false);
                    });
            }
        }
        // Get the pickup populations data -> DEPENDS ON: client, aseg province
        function getPoblacionesAseg(clientId, provincia) {
            if (provincia == null) {
                vm.genericData.poblaciones.aseg.list = null;
                if (vm.genericData.poblaciones.aseg.selected.id != null) {
                    vm.genericData.poblaciones.aseg.selected = { id: null, nombre: null };
                }
            } else {
                vm.genericData.poblaciones.aseg.loading = true;
                genericDataService.getPopulations(clientId, provincia)
                    .then(function (res) {
                        vm.genericData.poblaciones.aseg.loading = false;
                        vm.genericData.poblaciones.aseg.list = res;
                        selectChanged(vm.genericData.poblaciones.aseg.list,
                            vm.genericData.poblaciones.aseg.selected, false);
                    });
            }
        }
        // Get the colectives data -> DEPENDS ON: client
        function getColectivos(clientId) {
            if (clientId == null) {
                vm.genericData.colectivos.list = null;
                vm.genericData.colectivos.selected = { id: null, nombre: null };
                return;
            }
            vm.genericData.colectivos.loading = true;
            genericDataService.getColectivos(clientId)
                .then(function (res) {
                    vm.genericData.colectivos.loading = false;
                    vm.genericData.colectivos.list = res;
                    selectChanged(vm.genericData.colectivos.list, vm.genericData.colectivos.selected);
                });
        }
        // Get the vehicle type data -> DEPENDS ON: client
        function getTiposVhc(clientId) {
            if (clientId == null) {
                vm.genericData.tiposVehiculo.list = null;
                vm.genericData.tiposVehiculo.selected = { id: null, nombre: null };
                return;
            }
            vm.genericData.tiposVehiculo.loading = true;
            genericDataService.getTiposVhc(clientId)
                .then(function (res) {
                    vm.genericData.tiposVehiculo.loading = false;
                    vm.genericData.tiposVehiculo.list = res;
                    selectChanged(vm.genericData.tiposVehiculo.list, vm.genericData.tiposVehiculo.selected);

                    if (vm.genericData.tiposVehiculo.selected.id == null && defaultVal.tipoVHC) {
                        var v = findByProperty(vm.genericData.tiposVehiculo.list, 'isDefault', true);
                        if (v !== null) {
                            vm.genericData.tiposVehiculo.selected = v;
                        }
                        //defaultVal.tipoVHC = false;
                    }
                });
        }
        // Get the incident type data -> DEPENDS ON: client
        function getTiposIncidencia(clientId) {
            if (clientId == null) {
                vm.genericData.tiposIncidencia.list = null;
                vm.genericData.tiposIncidencia.selected = { id: null, nombre: null };
                vm.genericData.tiposIncidencia.selectedFin = { id: null, nombre: null };
                return;
            }
            vm.genericData.tiposIncidencia.loading = true;
            genericDataService.getTiposIncidencia(clientId)
                .then(function (res) {
                    vm.genericData.tiposIncidencia.loading = false;
                    vm.genericData.tiposIncidencia.list = res;
                    selectChanged(vm.genericData.tiposIncidencia.list, vm.genericData.tiposIncidencia.selected);
                    selectChanged(vm.genericData.tiposIncidencia.list, vm.genericData.tiposIncidencia.selectedFin);

                    if (vm.genericData.tiposIncidencia.selected.id == null && defaultVal.tipoInc) {
                        var i = findByProperty(vm.genericData.tiposIncidencia.list, 'nombre', 'Indefinida');
                        if (i !== null) {
                            vm.genericData.tiposIncidencia.selected = i;
                        }
                        //defaultVal.tipoInc = false;
                    }
                });
        }
        // Get the fault data -> DEPENDS ON: incident type
        function getAverias(tipoIncidenciaId, clientId) {
            if (tipoIncidenciaId == null || clientId == null) {
                vm.genericData.averias.default.list = null;
                vm.genericData.averias.default.selected = { id: null, nombre: null };
            } else {
                vm.genericData.averias.default.loading = true;
                genericDataService.getAverias(tipoIncidenciaId, clientId)
                    .then(function (res) {
                        vm.genericData.averias.default.loading = false;
                        vm.genericData.averias.default.list = res;
                        selectChanged(vm.genericData.averias.default.list, vm.genericData.averias.default.selected);
                    });
            }
        }
        // Get the end fault data -> DEPENDS ON: incident type
        function getAveriasFin(tipoIncidenciaId, clientId) {
            if (tipoIncidenciaId == null || clientId == null) {
                vm.genericData.averias.fin.list = null;
                vm.genericData.averias.fin.selected = { id: null, nombre: null };
            } else {
                vm.genericData.averias.fin.loading = true;
                genericDataService.getAverias(tipoIncidenciaId, clientId)
                    .then(function (res) {
                        vm.genericData.averias.fin.loading = false;
                        vm.genericData.averias.fin.list = res;
                        selectChanged(vm.genericData.averias.fin.list, vm.genericData.averias.fin.selected);
                    });
            }
        }

        function getProductoTarifas() {
            /*jshint maxcomplexity:false */
            var tarifaId = vm.genericData.tarifas.selected && vm.genericData.tarifas.selected.id;
            var productoId = vm.genericData.productos.selected && vm.genericData.productos.selected.id;
            if (!tarifaId || !productoId) { return; }
            genericDataService.tarifaProducto(tarifaId, productoId)
                .then(function (res) {
                    vm.linea.lineaOrdenCantidad = 1;
                    vm.linea.lineaOrdenPrecio = res.precio;
                    vm.linea.lineaOrdenDescuento = res.porcentaje;
                    vm.linea.lineaOrdenDesc = vm.genericData.productos.selected.nombre;
                    recalcularTotal();
                });
        }

        function getTiposFin(clientId) {
            if (clientId == null) {
                vm.genericData.tiposFin.list = null;
                vm.genericData.tiposFin.selected = { id: null, nombre: null };
                return;
            }
            vm.genericData.tiposFin.loading = true;
            genericDataService.getTiposFin(clientId)
                .then(function (res) {
                    vm.genericData.tiposFin.loading = false;
                    vm.genericData.tiposFin.list = res;
                    selectChanged(vm.genericData.tiposFin.list, vm.genericData.tiposFin.selected);
                });
        }

        function getLineasImpuesto(orderId) {
            ordersService.getLineasImpuesto(orderId)
                .then(function (res) {
                    vm.lineasImpuesto = res.data;
                });
        }

        function defaultValues() {
            defaultVal.tipoInc = true;
            defaultVal.tipoVHC = true;
            defaultVal.empresa = true;
            defaultVal.tipoFlota = true;
            defaultVal.baseSal = true;
            vm.orden.orderEstado = 0;
        }

        //Valor inicial selects y combos
        function setCombosInitialData() {
            //Panel superior
            vm.genericData.empresas.selected = { nombre: vm.orden.empresaName, id: vm.orden.empresaId };
            selectChanged(vm.genericData.empresas.list, vm.genericData.empresas.selected);
            vm.genericData.clients.selected = { nombre: vm.orden.clienteName, id: vm.orden.clienteId };
            selectChanged(vm.genericData.clients.list, vm.genericData.clients.selected);
            //Datos solicitante
            vm.genericData.tiposOrden.selected = { nombre: null, id: vm.orden.orderTipoOrdenId };
            selectChanged(vm.genericData.tiposOrden.list, vm.genericData.tiposOrden.selected);
            vm.genericData.colectivos.selected = { nombre: vm.orden.colectivoAsegName, id: vm.orden.colectivoAsegId };
            selectChanged(vm.genericData.colectivos.list, vm.genericData.colectivos.selected);
            //vm.genericData.tiposFlota.selected = { nombre: vm.orden.tipoFlotaName, id: vm.orden.tipoFlotaId };
            //selectChanged(vm.genericData.tiposFlota.list, vm.genericData.tiposFlota.selected);
            vm.genericData.tiposSubFlota.selected = { nombre: vm.orden.tipoSubFlotaName, id: vm.orden.tipoSubFlotaId };
            selectChanged(vm.genericData.tiposSubFlota.list, vm.genericData.tiposSubFlota.selected);
            //Datos vehiculo
            vm.genericData.vehicleBrands.selected = { nombre: vm.orden.orderGruMarca, id: vm.orden.orderGruMarcaId };
            selectChanged(vm.genericData.vehicleBrands.list, vm.genericData.vehicleBrands.selected, false);
            vm.genericData.vehicleModels.selected = { nombre: vm.orden.orderGruModelo, id: vm.orden.orderGruModeloId };
            selectChanged(vm.genericData.vehicleModels.list, vm.genericData.vehicleModels.selected, false);
            vm.genericData.vehicleColors.selected = { nombre: vm.orden.orderGruColor, id: null };
            selectChanged(vm.genericData.vehicleColors.list, vm.genericData.vehicleColors.selected, false);
            vm.genericData.tiposVehiculo.selected = { nombre: vm.orden.tipoVhcDesc, id: vm.orden.tipoVhcId };
            selectChanged(vm.genericData.tiposVehiculo.list, vm.genericData.tiposVehiculo.selected);
            //Datos asegurado
            vm.genericData.paises.selectedAseg = { nombre: vm.orden.orderGruPaisAseg, id: null };
            selectChanged(vm.genericData.paises.list, vm.genericData.paises.selectedAseg, false);
            vm.genericData.provinces.aseg.selected = { nombre: vm.orden.orderGruProvAseg, id: null };
            selectChanged(vm.genericData.provinces.aseg.list, vm.genericData.provinces.aseg.selected, false);
            vm.genericData.poblaciones.aseg.selected = { nombre: vm.orden.orderGruPobAseg, id: null };
            selectChanged(vm.genericData.poblaciones.aseg.list, vm.genericData.poblaciones.aseg.selected, false);
            //Datos incidente
            vm.genericData.tiposIncidencia.selected = { nombre: vm.orden.tipoIncDesc, id: vm.orden.tipoIncId };
            selectChanged(vm.genericData.tiposIncidencia.list, vm.genericData.tiposIncidencia.selected);
            vm.genericData.averias.default.selected = { nombre: vm.orden.averiaDesc, id: vm.orden.averiaId };
            selectChanged(vm.genericData.averias.default.list, vm.genericData.averias.default.selected);
            //Recogida
            vm.genericData.tiposRecogida.selected = { nombre: null, id: vm.orden.orderGruTipoRec };
            selectChanged(vm.genericData.tiposRecogida.list, vm.genericData.tiposRecogida.selected);
            vm.genericData.bases.selectedRec = { nombre: vm.orden.baseRecName, id: vm.orden.baseRecId };
            selectChanged(vm.genericData.bases.list, vm.genericData.bases.selectedRec);
            vm.genericData.talleres.selectedRec = { nombre: vm.orden.tallerRecName, id: vm.orden.tallerRecId };
            selectChanged(vm.genericData.talleres.list, vm.genericData.talleres.selectedRec);
            vm.genericData.colaboradores.selectedRec = { nombre: null, id: vm.orden.colabRecId };
            selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedRec);
            //Entrega
            vm.genericData.tiposEntrega.selected = { nombre: null, id: vm.orden.orderGruTipoEnt };
            selectChanged(vm.genericData.tiposEntrega.list, vm.genericData.tiposEntrega.selected);
            vm.genericData.bases.selectedEnt = { nombre: vm.orden.baseEntName, id: vm.orden.baseEntId };
            selectChanged(vm.genericData.bases.list, vm.genericData.bases.selectedEnt);
            vm.genericData.talleres.selectedEnt = { nombre: vm.orden.tallerEntName, id: vm.orden.tallerEntId };
            selectChanged(vm.genericData.talleres.list, vm.genericData.talleres.selectedEnt);
            vm.genericData.colaboradores.selectedEnt = { nombre: null, id: vm.orden.colabEntId };
            selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedEnt);
            //Panel Salida
            vm.genericData.bases.selectedSalida = { nombre: vm.orden.baseSalidaName, id: vm.orden.baseSalidaId };
            selectChanged(vm.genericData.bases.list, vm.genericData.bases.selectedSalida);
            //Datos asignacion
            vm.genericData.operarios.selected = { nombre: vm.orden.operarioName, id: vm.orden.operarioId };
            selectChanged(vm.genericData.operarios.list, vm.genericData.operarios.selected);
            vm.genericData.vehiculos.selected = { nombre: vm.orden.flotaDesc, id: vm.orden.flotaId };
            selectChanged(vm.genericData.vehiculos.list, vm.genericData.vehiculos.selected);
            vm.genericData.colaboradores.selectedAssignmentData = { nombre: vm.orden.colaboradorName, id: vm.orden.colaboradorId };
            selectChanged(vm.genericData.colaboradores.list, vm.genericData.colaboradores.selectedAssignmentData);
            
            //Datos finalizacion
            vm.genericData.tiposFin.selected = { nombre: vm.orden.tipoFinDesc, id: vm.orden.tipoFinId };
            selectChanged(vm.genericData.tiposFin.list, vm.genericData.tiposFin.selected);
            vm.genericData.nocFes.selected = { nombre: null, id: vm.orden.orderGruNocFes };
            selectChanged(vm.genericData.nocFes.list, vm.genericData.nocFes.selected);
            vm.genericData.tiposIncidencia.selectedFin = { nombre: vm.orden.tipoIncFinDesc, id: vm.orden.tipoIncFinId };
            selectChanged(vm.genericData.tiposIncidencia.list, vm.genericData.tiposIncidencia.selectedFin);
            vm.genericData.averias.fin.selected = { nombre: vm.orden.averiaFinDesc, id: vm.orden.averiaFinId };
            selectChanged(vm.genericData.averias.fin.list, vm.genericData.averias.fin.selected);
            //VALORACION
            vm.genericData.formasPago.selected = { nombre: vm.orden.tipoPagoDesc, id: vm.orden.tipoPagoId };
            selectChanged(vm.genericData.formasPago.list, vm.genericData.formasPago.selected);

            // ADDRESS
            vm.genericData.addressSearcherPoblaciones.list = [];
            vm.genericData.addressSearcherProvincias.list = [];
            vm.genericData.addressSearcherPaises.list = [];
            vm.genericData.poblaciones.selectedRec = { id: null, desc: vm.orden.orderPobRec, disableOnChangeEvent: true };
            vm.genericData.provinces.selectedRec = { id: null, desc: vm.orden.orderProvRec, disableOnChangeEvent: true };
            vm.genericData.paises.selectedRec = { id: null, desc: vm.orden.orderPaisRec, disableOnChangeEvent: true };
            vm.genericData.poblaciones.selectedEnt = { id: null, desc: vm.orden.orderPobEnt, disableOnChangeEvent: true };
            vm.genericData.provinces.selectedEnt = { id: null, desc: vm.orden.orderProvEnt, disableOnChangeEvent: true };
            //vm.genericData.paises.selectedEnt = { id: null, desc: vm.orden.orderPaisEnt, disableOnChangeEvent: true };
            //vm.genericData.poblaciones.selectedRec = { id: vm.orden.orderPobRecId, desc: vm.orden.orderPobRec, disableOnChangeEvent: true };
            //vm.genericData.provinces.selectedRec = { id: vm.orden.orderProvRecId, desc: vm.orden.orderProvRec, disableOnChangeEvent: true };
            //vm.genericData.paises.selectedRec = { id: vm.orden.orderPaisEntId, desc: vm.orden.orderPaisRec, disableOnChangeEvent: true };
            //vm.genericData.poblaciones.selectedEnt = { id: vm.orden.orderPobEntId, desc: vm.orden.orderPobEnt, disableOnChangeEvent: true };
            //vm.genericData.provinces.selectedEnt = { id: vm.orden.orderProvEntId, desc: vm.orden.orderProvEnt, disableOnChangeEvent: true };
            vm.genericData.paises.selectedEnt = { id: vm.orden.orderPaisEntId, desc: vm.orden.orderPaisEnt, disableOnChangeEvent: true };

            if (common.isNullOrUndefined(vm.genericData.clients.selected))
                setAddressSearcher(null);
            else
                setAddressSearcher(vm.genericData.clients.selected);
        }

        function setCombosInitialDataDefault() {
            //Panel superior
            vm.genericData.empresas.selected = { id: null };
            vm.genericData.clients.selected = { id: null };
            //Datos solicitante
            vm.genericData.tiposOrden.selected = { id: null };
            vm.genericData.colectivos.selected = { id: null };
            vm.genericData.tiposFlota.selected = { id: null };
            vm.genericData.tiposSubFlota.selected = { id: null };
            //Datos vehiculo
            vm.genericData.vehicleBrands.selected = { id: null };
            vm.genericData.vehicleModels.selected = { id: null };
            vm.genericData.vehicleColors.selected = { id: null };
            vm.genericData.tiposVehiculo.selected = { id: null };
            //Datos asegurado
            vm.genericData.paises.selectedAseg = { id: null };
            vm.genericData.provinces.aseg.selected = { id: null };
            vm.genericData.poblaciones.aseg.selected = { id: null };
            //Datos incidente
            vm.genericData.tiposIncidencia.selected = { id: null };
            vm.genericData.averias.default.selected = { id: null };
            //Recogida
            //vm.genericData.tiposRecogida.selected = { id: null };
            vm.genericData.bases.selectedRec = { id: null };
            vm.genericData.talleres.selectedRec = { id: null };

            vm.genericData.addressSearcherPoblaciones.list = [];
            vm.genericData.addressSearcherProvincias.list = [];
            vm.genericData.addressSearcherPaises.list = [];
            vm.genericData.paises.selectedRec = { id: null, desc: null, disableOnChangeEvent: true };
            vm.genericData.provinces.selectedRec = { id: null, desc: null, disableOnChangeEvent: true };
            vm.genericData.poblaciones.selectedRec = { id: null, desc: null, disableOnChangeEvent: true };
            vm.genericData.paises.selectedEnt = { id: null, desc: null, disableOnChangeEvent: true };
            vm.genericData.provinces.selectedEnt = { id: null, desc: null, disableOnChangeEvent: true };
            vm.genericData.poblaciones.selectedEnt = { id: null, desc: null, disableOnChangeEvent: true };
            setAddressSearcher(null);

            //Entrega
            //vm.genericData.tiposEntrega.selected = { id: null };
            vm.genericData.bases.selectedEnt = { id: null };
            vm.genericData.talleres.selectedEnt = { id: null };
            //Panel Salida
            vm.genericData.bases.selectedSalida = { id: null };
            //Datos asignacion
            vm.genericData.operarios.selected = { id: null };
            vm.genericData.vehiculos.selected = { id: null };
            //Datos finalizacion
            vm.genericData.tiposFin.selected = { id: null };
            vm.genericData.nocFes.selected = { id: null };
            vm.genericData.tiposIncidencia.selectedFin = { id: null };
            vm.genericData.averias.fin.selected = { id: null };
            //VALORACION
            vm.genericData.formasPago.selected = { id: null };
        }

        function setDates() {
            vm.dates.orden = vm.orden.orderDate && new Date(vm.orden.orderDate);
            vm.dates.alta = vm.orden.orderFechaAlta && new Date(vm.orden.orderFechaAlta);
            vm.dates.asignacion = vm.orden.orderFechaAsig && new Date(vm.orden.orderFechaAsig);
            vm.dates.entrega = vm.orden.orderFechaEnt && new Date(vm.orden.orderFechaEnt);
            vm.dates.finalizado = vm.orden.orderFechaFin && new Date(vm.orden.orderFechaFin);
            vm.dates.aceptado = vm.orden.orderFechaAcep && new Date(vm.orden.orderFechaAcep);
            vm.dates.inicio = vm.orden.orderFechaIni && new Date(vm.orden.orderFechaIni);
            vm.dates.localizacion = vm.orden.orderFechaLoc && new Date(vm.orden.orderFechaLoc);
            vm.dates.entPrev = vm.orden.orderFechaLimiteEnt && new Date(vm.orden.orderFechaLimiteEnt);
            vm.dates.recPrev = vm.orden.orderFechaLocPrev && new Date(vm.orden.orderFechaLocPrev);

            vm.dates.errors = [];
        }

        function setObservaciones() {
            //Observaciones
            parseObservaciones(vm.observaciones.obs, vm.orden.orderObs);
            //Observaciones internas
            parseObservaciones(vm.observaciones.internas, vm.orden.orderObsInt);
            //Observaciones cliente
            parseObservaciones(vm.observaciones.cliente, vm.orden.orderObsCliente);
        }

        function parseObservaciones(obs, data) {
            if (data == null) {
                obs.list = [];
            } else {
                try { obs.list = JSON.parse(data); }
                catch (e) {
                    data = JSON.stringify([{ text: data }]);
                    obs.list = JSON.parse(data);
                }
            }
        }

        // Try to find the selected element in the list using the id property
        // If requireId is false it will keep the name even when id is null
        function selectChanged(list, selected, requireId) {
            requireId = (typeof requireId === 'undefined') ? true : requireId; //RequireId defaults to TRUE
            if (!list || !selected) { return; } //If the is no list or element exit
            if (list.length <= 0 || selected.id == null) { // Delete element unless it doesnt require id
                if (!requireId) { return; }
                //selected.nombre = null;
                //selected.id = null;
                return;
            }
            var find = findByProperty(list, 'id', selected.id);
            if (find) {
                Object.assign(selected, find);
            } else {
                selected.nombre = null;
                selected.id = null;
            }
        }

        function findByProperty(array, property, id) {
            if (array === null) { return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
        }

        function volverListado() {
            if ($stateParams.fromSearchRedirectTo == null) {
                if ((vm.from === 'ordenes_activas' || vm.from === 'mapa' || vm.from === 'planificador' || vm.from === 'ordenes_programadas') && !vm.stateParams.allOrdersOpen) {
                    if (vm.from === 'ordenes_activas')
                        $state.go('flota.OrdenesActivas');
                    else if (vm.from === 'ordenes_programadas')
                        $state.go('flota.ordenes_programadas');
                    else if (vm.from === 'mapa')
                        $state.go('flota.mapa');
                    else if (vm.from === 'planificador')
                        $state.go('flota.planificador');
                    else
                        $state.go('flota.ordenes.listado');
                }
                else if (vm.from === 'ordenes_activas') {
                    $state.go('flota.ordenes.listado');
                    $state.go('flota.OrdenesActivas');
                }
                else if (vm.from === 'ordenes_programadas') {
                    $state.go('flota.ordenes_programadas');
                    $state.go('flota.ordenes_programadas');
                }
                else if (vm.from === 'mapa' && vm.stateParams.allOrdersOpen) {
                    $state.go('flota.ordenes.listado');
                    $state.go('flota.mapa');
                }
                else if (vm.from === 'planificador' && vm.stateParams.allOrdersOpen) {
                    $state.go('flota.ordenes.listado');
                    $state.go('flota.planificador');
                }
                else {
                    $state.go('flota.ordenes.listado');
                }
            } else {
                $state.go($stateParams.fromSearchRedirectTo);
            }
        }

        function effectClass(target) {
            vm.effects = {};
            vm.effects[target] = true;
            setTimeout(function () {
                vm.effects[target] = undefined;
            }, 3000);
        }

        function pasarActiva() {
            var currentDate = Date.NewDate();
            var futureDate = new Date(currentDate.getTime() + (vm.tiempoDeProgramacion * 60 * 1000));
            var orderDate = new Date(vm.orden.orderDate);
            // Si es menor igual es activa, sino no activa(este caso)
            if (vm.orden.orderProgramada === true && orderDate > futureDate) {
                vm.esPosiblePasarActiva = true;
            }

        }

        function pasarComoActiva() {
            vm.dates.orden = Date.NewDate();
            saveAndClose();
        }

        function copyFromDriver() {
            vm.orden.orderGruNomAseg = vm.orden.orderNomConductor;
            vm.orden.orderGruApeAseg = vm.orden.apecontacto;
            vm.orden.orderGruTfnoAseg = vm.orden.orderTfnoConductor;
        }

        function clearRecDir() {
            vm.orden.orderDirRec = null;
            vm.genericData.provinces.recogida.selected = null;
            vm.genericData.poblaciones.recogida.selected = null;
            vm.orden.orderCpRec = null;
            vm.orden.orderLatRec = null;
            vm.orden.orderLongRec = null;
            vm.orden.dUbicacionRec = null;
        }

        function clearEntDir() {
            vm.orden.orderDirEnt = null;
            vm.genericData.provinces.entrega.selected = null;
            vm.genericData.poblaciones.entrega.selected = null;
            vm.orden.orderCpEnt = null;
            vm.orden.orderLatEnt = null;
            vm.orden.orderLongEnt = null;
            vm.orden.dUbicacionEnt = null;
        }

        function onClientTryChange() {
            return $q(function (resolve, reject) {
                if (vm.orden.orderEstadoFac >= 2) {
                    simpleModalService.yesNoModal('Confirmación cambio cliente',
                        `El servicio esta valorado, si se cambia el cliente se guardará la orden y se
					generará una valoración nueva. ¿Desea cambiar el cliente?`).then(function (result) {
                            if (result) {
                                needToRetarifar = true;
                                resolve();
                            } else {
                                needToRetarifar = false;
                                reject();
                            }
                        }, function () {
                            reject();
                        });
                } else {
                    resolve();
                }
            });
        }

        function toggleDateFormGroup() {
            vm.showDateFormGroup = !vm.showDateFormGroup;
            if (vm.showDateFormGroup) {
                vm.orden.orderProgramada = true;
                vm.dates.orden = null;
            }
        }

        function validate() {
            var hasError = false;

            hasError = isValidFecha();

            return hasError;
        }

        function isValidFecha() {

            vm.fechaError = false;

            if (vm.orden.orderProgramada) {
                return true;
            }

            if (vm.dates.asignacion === null)
                return true;

            if (vm.dates.orden === null)
                return true;
            
            var momentOrden = moment(vm.dates.orden);
            var momentAsignacion = moment(vm.dates.asignacion);
            
            if (momentAsignacion.diff(momentOrden) < 0) {
                vm.fechaError = 'La fecha de asignación (' + momentAsignacion.format('DD/MM/YYYY hh:mm') + ') es anterior a la fecha de la orden.';
                return false;
            }

            return true;
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if(!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

        function preLoad() {
            ordersService.getOrderById(preloadOrder)
				.then(function (res) {
                    var preload = res.data;

                    vm.orden.empresaId = preload.empresaId;
                    vm.orden.clienteId = preload.clienteId;
                    vm.orden.orderGruExpediente = preload.orderGruExpediente;

                    //Datos de solicitante
                    vm.orden.orderTipoOrdenId = preload.orderTipoOrdenId;
                    vm.orden.orderGruContacto = preload.orderGruContacto;
                    vm.orden.colectivoAsegId = preload.colectivoAsegId;
                    vm.orden.tipoSubFlotaId = preload.tipoSubFlotaId;

                    //Datos de vehiculo
                    vm.orden.orderGruMatricula = preload.orderGruMatricula;
                    vm.orden.numBastidor = preload.numBastidor;
                    vm.orden.orderGruModelo = preload.orderGruModelo;
                    vm.orden.orderGruModeloId = preload.orderGruModeloId;
                    vm.orden.orderGruMarca = preload.orderGruMarca;
                    vm.orden.orderGruMarcaId = preload.orderGruMarcaId;
                    vm.orden.orderGruColor = preload.orderGruColor;
                    vm.orden.tipoVhcId = preload.tipoVhcId;

                    //Datos de incidente
                    vm.orden.tipoIncId = preload.tipoIncId;
                    vm.orden.averiaId = preload.averiaId;
                    vm.orden.orderTaxPax = preload.orderTaxPax;

                    //Datos de conductor
                    vm.orden.orderNomConductor = preload.orderNomConductor;
                    vm.orden.apecontacto = preload.apecontacto;
                    vm.orden.orderTfnoConductor = preload.orderTfnoConductor;
                    vm.orden.orderEmailContacto = preload.orderEmailContacto;

                    //Datos de asegurado
                    vm.orden.orderGruNomAseg = preload.orderGruNomAseg;
                    vm.orden.orderGruApeAseg = preload.orderGruApeAseg;
                    vm.orden.orderGruTfnoAseg = preload.orderGruTfnoAseg;
                    vm.orden.orderGruNifAseg = preload.orderGruNifAseg;
                    vm.orden.orderGruPaisAseg = preload.orderGruPaisAseg;
                    vm.orden.orderGruProvAseg = preload.orderGruProvAseg;
                    vm.orden.orderGruPobAseg = preload.orderGruPobAseg;
                    vm.orden.orderGruCPAseg = preload.orderGruCPAseg;
                    vm.orden.orderGruDirAseg = preload.orderGruDirAseg;

                    //Datos de recogida
                    vm.orden.orderGruTipoRec = preload.orderGruTipoRec;
                    vm.orden.baseRecId = preload.baseRecId;
                    vm.orden.tallerRecId = preload.tallerRecId;
                    vm.orden.colabRecId = preload.colabRecId;
                    vm.orden.orderPaisRecId = preload.orderPaisRecId;
                    vm.orden.orderPaisRec = preload.orderPaisRec;
                    vm.orden.orderProvRecId = preload.orderProvRecId;
                    vm.orden.orderProvRec = preload.orderProvRec;
                    vm.orden.orderPobRecId = preload.orderPobRecId;
                    vm.orden.orderPobRec = preload.orderPobRec;

                    vm.orden.orderCpRec = preload.orderCpRec;
                    vm.orden.orderLatRec = preload.orderLatRec;
                    vm.orden.orderLongRec = preload.orderLongRec;
                    vm.orden.orderDirRec = preload.orderDirRec;

                    vm.orden.dUbicacionRec = preload.dUbicacionRec;
                    vm.orden.orderFechaLocPrev = preload.orderFechaLocPrev;
                    vm.orden.nombreFirmaRecogida = preload.nombreFirmaRecogida;
                    vm.orden.tfnoFirmaRecogida = preload.tfnoFirmaRecogida;

                    //Datos de entrega
                    vm.orden.orderGruTipoEnt = preload.orderGruTipoEnt;
                    vm.orden.baseEntId = preload.baseEntId;
                    vm.orden.tallerEntId = preload.tallerEntId;
                    vm.orden.colabEntId = preload.colabEntId;
                    vm.orden.orderPaisEntId = preload.orderPaisEntId;
                    vm.orden.orderPaisEnt = preload.orderPaisEnt;
                    vm.orden.orderProvEntId = preload.orderProvEntId;
                    vm.orden.orderProvEnt = preload.orderProvEnt;
                    vm.orden.orderPobEntId = preload.orderPobEntId;
                    vm.orden.orderPobEnt = preload.orderPobEnt;

                    vm.orden.orderCpEnt = preload.orderCpEnt;
                    vm.orden.orderLatEnt = preload.orderLatEnt;
                    vm.orden.orderLongEnt = preload.orderLongEnt;
                    vm.orden.orderDirEnt = preload.orderDirEnt;

                    vm.orden.dUbicacionEnt = preload.dUbicacionEnt;
                    vm.orden.orderFechaLimiteEnt = preload.orderFechaLimiteEnt;
                    vm.orden.nombreFirmaEntrega = preload.nombreFirmaEntrega;
                    vm.orden.tfnoFirmaEntrega = preload.tfnoFirmaEntrega;


                    vm.orden.baseSalidaId = preload.baseSalidaId;
                    vm.orden.orderGruKmsPrevistos = preload.orderGruKmsPrevistos;

                    vm.orden.orderObs = preload.orderObs;
                    //vm.orden.orderObsInt = preload.orderObsInt;
                    //vm.orden.orderObsCliente = preload.orderObsCliente;


                    //TAX
                    vm.orden.orderTaxExpediente = preload.orderTaxExpediente;
                    vm.orden.numVuelo = preload.numVuelo;
                    vm.orden.orderTaxPax = preload.orderTaxPax;
                    vm.orden.orderTaxEquipajePeq = preload.orderTaxEquipajePeq;
                    vm.orden.orderTaxEquipajeMed = preload.orderTaxEquipajeMed;
                    vm.orden.orderTaxEquipajeGran = preload.orderTaxEquipajeGran;
                    vm.orden.orderTaxSillasG1 = preload.orderTaxSillasG1;
                    vm.orden.orderTaxSillasG2 = preload.orderTaxSillasG2;
                    vm.orden.orderTaxSillasG3 = preload.orderTaxSillasG3;
                    vm.orden.orderTaxBolsasGolf = preload.orderTaxBolsasGolf;
                    vm.orden.orderTaxTransportines = preload.orderTaxTransportines;
                    vm.orden.orderTaxBicicletas = preload.orderTaxBicicletas;
                    vm.orden.orderTaxNombrePas = preload.orderTaxNombrePas;
                    vm.orden.orderTaxApellidoPas = preload.orderTaxApellidoPas;
                    vm.orden.orderTaxTfnoPas = preload.orderTaxTfnoPas;
                    vm.orden.orderTaxMatricula = preload.orderTaxMatricula;


                    setDates();
                    setObservaciones();
                    setCombosInitialData();

                    vm.dates.orden = Date.NewDate();
                });
        }
    }
})();